import $$ from 'dom7';
import {
  setCountryCode,
  createDobCalendar,
  isIndiaOnly,
  applyCountryScope,
  renderBankDetails,
  renderDepositAccount,
  validateScope,
} from './auth.js';
import {
  clearSession,
  imageError,
  utrError,
  accountNumberError,
  ifscError,
} from './api.js';
import {
  initKycPage,
  destroyKycPage,
  initLimitsPage,
  walletGate,
  walletRefusal,
  depositAllowance,
  depositRefusal,
} from './kyc.js';
import {
  initHistoryPage,
  initTxnDetailsPage,
  takeRepeat,
} from './history.js';

import HomePage from '../pages/home.f7.html';
import LoginPage from '../pages/login.f7.html';
import RegisterPage from '../pages/register.f7.html';
import PaymentPage from '../pages/payment.f7.html';
import LockerPage from '../pages/locker.f7.html';
import DepositPage from '../pages/deposit.f7.html';
import DepositMoneyPage from '../pages/deposit-money.f7.html';
import TransferPage from '../pages/transfer.f7.html';
import TransactionPage from '../pages/transaction.f7.html';
import TransactionDetailsPage from '../pages/transaction-details.f7.html';
import InvestPage from '../pages/invest.f7.html';
import InvestDashboardPage from '../pages/invest-dashboard.f7.html';
import ReturnPage from '../pages/returns.f7.html';
import InvestWithdrawPage from '../pages/invest-withdraw.f7.html';
import MoneyTransferPage from '../pages/money-transfer.f7.html';
import FeesTransactionPage from '../pages/fees.f7.html';
import EarningPage from '../pages/earning.f7.html';
import MyTeamPage from '../pages/my-team.f7.html';
import ServicesPage from '../pages/services.f7.html';
import RechargePage from '../pages/recharge.f7.html';
import KycPage from '../pages/kyc.f7.html';
import WalletLimitsPage from '../pages/wallet-limits.f7.html';

import NotFoundPage from '../pages/404.f7.html';
var baseURL = "https://youpaywallet.com/";

/*
 * Route guard for anything that spends or exposes money.
 *
 * The rest of the app gates these by rendering href="/login/" in the template
 * and rewriting it once the session is confirmed. That leaves deep links, the
 * back button and any page holding a hard-coded URL unprotected; a beforeEnter
 * hook covers every way in.
 */
function isSignedIn() {
  return localStorage.getItem('isloggedIN') === 'true' &&
    !!localStorage.getItem('authToken');
}

function requireSignIn(to, from, resolve, reject) {
  var router = this;
  if (isSignedIn()) {
    resolve();
    return;
  }
  reject();
  /* Next tick: the router is still unwinding the rejected navigation, and a
     navigate() issued from inside the hook is dropped. */
  setTimeout(function() {
    router.app.toast.show({ text: 'Please sign in to continue', closeTimeout: 2500 });
    router.navigate('/login/');
  }, 0);
}
var country = localStorage.getItem('country');

// Currency configuration map
const currencyConfig = {
  'IN': { locale: 'en-IN', currency: 'INR' },
  'BD': { locale: 'en-BD', currency: 'BDT' },
  'NP': { locale: 'en-NP', currency: 'NPR' },
  'default': { locale: 'en-IN', currency: 'INR' }
};

const config = currencyConfig[country] || currencyConfig['default'];
let INR = new Intl.NumberFormat(config.locale, {
  style: 'currency',
  currency: config.currency,
  minimumFractionDigits: 0,
});
let INR2 = new Intl.NumberFormat(config.locale, {
  style: 'currency',
  currency: config.currency,
  minimumFractionDigits: 2,
});
const isPlay = false;
var routes = [
  {
    path: '/',
    component: HomePage,
    name: 'Home',
    on: {
      pageInit: function (e, page) {
        var app = this.app;
        //get helpline Number
        app.methods.getSettings(function(data) {
          $('.helpLinenumber').html(data.help);
          //make the Call us row actually dial
          $('.help-call-link').attr('href', data.help ? 'tel:+91' + data.help : '#');
          $$('.telegram-link').attr('href', data.telegram);
          //show or hide how to use popup
          //app.popup.open('.sheet-loan--game');
          // if(localStorage.getItem('howToUse') != 'true') {
          //   app.popup.open('.sheet-loan--htu');
          //   var player = new videojs('vid1', {
          //     controls: true,
          //     autoplay: false,
          //     preload: 'auto',
          //     fluid: true,
          //     responsive: true,
          //     sources: [{src: data.ytVideo, type: 'video/youtube'}],
          //     "techOrder": ["youtube"],
          //   });
          // } else {
          //   app.popup.close('.sheet-loan--htu');
          // }
        });
        //on open of how to use popup
        $$('.sheet-loan--htu').on('popup:open', function (e, popup) {
          app.dialog.progress('Loading...');
          app.methods.getSettings(function(data) {
            app.dialog.close();
            app.popup.open('.sheet-loan--htu');
            var player = new videojs('vid1', {
              controls: true,
              autoplay: false,
              preload: 'auto',
              fluid: true,
              responsive: true,
              sources: [{src: data.ytVideo, type: 'video/youtube'}],
              "techOrder": ["youtube"],
            });
          });
        });
        $$('.skip-if-watched').on('click', function() {
          localStorage.setItem('howToUse', 'true');
          app.popup.close('.sheet-loan--htu');
        });
        $$('.btn-game__dd').on('click', function() {
          app.popup.close('.sheet-loan--game');
          window.open('https://app.doubledragon.in/home', '_system');
        });
        //swiper slider
        var swiper = app.swiper.create('.swiper-container', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
            $('.profile-name').html(data.name);
            //app bar greeting uses the first name only
            $('.ypw-greet__name').html(data.name ? String(data.name).trim().split(' ')[0] : 'there');
            //the customer's own picture when an administrator has set one
            //(userinfo.profileImg), otherwise the initials avatar as before.
            //Read on every userinfo: a new picture comes with a new URL.
            var initialsAvatar = 'https://ui-avatars.com/api/?background=fbd2e4&color=ed1e79&length=2&rounded=true&bold=true&name='+data.name;
            var profilePicture = typeof data.profileImg === 'string' && /^https?:\/\//i.test(data.profileImg) ? data.profileImg : '';
            $$('.loggeninProfileUI').each(function(i, img) {
              //a picture that will not load falls back to the initials
              img.onerror = profilePicture ? function() { img.onerror = null; img.src = initialsAvatar; } : null;
              img.src = profilePicture || initialsAvatar;
            });
            $$('.profile-email').html(data.email);
            if(data.country == 'IN') {
              localStorage.setItem('country', 'IN');
              $$('.profile-phone').html('+91'+data.phone);
            } else if(data.country == 'BD') {
              localStorage.setItem('country', 'BD');
              $$('.profile-phone').html('+880'+data.phone);
            } else if(data.country == 'NP') {
              localStorage.setItem('country', 'NP');
              $$('.profile-phone').html('+977'+data.phone);
            } else {
              $$('.profile-phone').html(data.phone);
            }
            $$('.profile-address').html(data.address);
            $$('.profile-dob').html(data.dob);
            $$('.profile-link').attr('href','#');
            $$('.profile-link').addClass('popup-open');
            $$('.profile-link').attr('data-popup','#profile-popup');
            //dashboard
            //check if isPlay is true
            if(isPlay) {
              var link = 'https://app.youpaywallet.com/';
              $$('.item__link--locker').attr('href',link);
              $$('.item__link--transaction').attr('href',link);
              $$('.item__link--deposit').attr('href',link);
              $$('.item__link--withdraw').attr('href',link);
              $$('.invest-btn--home').attr('href',link);
              $$('.wallet__link').addClass('external');
              $$('.wallet__link').attr('target','_system');
              $$('.invest__card').addClass('hidden');
              $$('.game__card').addClass('hidden');
            } else {
              $$('.item__link--locker').attr('href','/locker/');
              $$('.item__link--transaction').attr('href','/transaction/wallet');
              $$('.item__link--deposit').attr('href','/deposit/');
              $$('.item__link--withdraw').attr('href','/withdraw/');
              $$('.invest-btn--home').attr('href','/invest/');
              $$('.invest__card').removeClass('hidden');
              $$('.game__card').removeClass('hidden');
              $$('.item_link--transfer').attr('href','/money-transfer/');
            }
            //get subscription details
            app.methods.getUserDataLocker(function(data) {
              if(data.status == 'success') {
                /* Painted from the same figures as the hero, so the two rows
                   always add up to the total shown there. */
                function paintWalletInfo(main, cashback) {
                  $$('.winfo--main').html(INR2.format(main));
                  $$('.winfo--cashback').html(INR2.format(cashback));
                  $$('.winfo--total').html(INR2.format(main + cashback));
                }
                if(data.subscription.status == '1') {
                  var main = +data.subscription.wallet;
                  var cashback = +data.subscription.cashbackWallet;
                  $$('.item-media__locker img').attr('src','assets/icons/locker-unlocked.png');
                  $$('.home__wallet--amount').html(INR2.format(main + cashback));
                  paintWalletInfo(main, cashback);
                }
                else if(data.subscription.status == '2') {
                  //cashback is not part of the balance shown in this state
                  $$('.home__wallet--amount').html(INR2.format(data.subscription.wallet));
                  paintWalletInfo(+data.subscription.wallet, 0);
                } else {

                }
              } else {
              }
            });
            //get investment details
            app.methods.getUserDataInvest(function(data) {
              if(data.status == 'success') {
                $$('.invest-btn--home').html('My Investment');
                $$('.invest-btn--home').attr('href','/invest-dashboard/');
              } else {
              }
            });
          } else {
            app.dialog.close();
            //remove authToken
            localStorage.removeItem('authToken');
            localStorage.setItem('isloggedIN', 'false');
            //check if isPlay is true
            if(isPlay) {
              var link = 'https://app.youpaywallet.com/';
              $$('.item__link--locker').attr('href',link);
              $$('.item__link--transaction').attr('href',link);
              $$('.item__link--deposit').attr('href',link);
              $$('.item__link--withdraw').attr('href',link);
              $$('.wallet__link').addClass('external');
              $$('.wallet__link').attr('target','_system');
            } else {
              
            }
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').on('click', function() {
          var shareLink = 'https://app.youpaywallet.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join YouPayWallet',
              text: 'Use my referral code to join YouPayWallet!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        // $$('.item_link--transfer').on('click', function() {
        //   app.toast.show({
        //     text: 'Money transfer to another person is not available right now!',
        //     closeTimeout: 3000,
        //   });
        // });
        /* The generic "This feature is coming soon!" toast used to be bound
           here, on the whole section, so it fired for anything inside --
           including the new "View all" link, which then toasted while
           navigating. app.js now answers per tile via [data-service] and names
           the service, so this is gone. (.home__wallet--transfer never existed
           on this page either.) */
        /* The balance on the hero is the two wallets added together, and they
           are not interchangeable -- cashback can be spent but never withdrawn
           or transferred. Show the split rather than a paragraph about it. */
        $$('.wallet_info').on('click', function() {
          app.sheet.open('#wallet-info-sheet');
        });
        //get games list
        $.post(baseURL+"app/php/games.php", {getGames: true}, function() {
        })
        .done(function(data) {
          if(data.status == 200) {
            $$('.games__list').empty();
            $.each(data.data, function(i, item) {
              $$('.games__list').append('<div class="col-card__help">\
              <div class="card card__help card-main" style="background-color: transparent;">\
                <div class="card-content">\
                  <div class="list media-list">\
                    <ul>\
                      <li>\
                        <a href="'+item.url+'" class="item-link item-content item__link--game external" target="_system">\
                          <div class="item-inner text-align-center">\
                            <div class="item-media"><img class="m-center" src="'+item.icon+'" width="40"/ style="border-radius: 8px;"></div>\
                            <div class="item-footer text-color-blue fw-600">'+item.name+'</div>\
                          </div></a></li>\
                      </ul>\
                  </div>\
                </div>\
              </div>\
            </div>');
            });
          }
        })
        .fail(function() {
        });
      }
    }
  },
  {
    path: '/login/',
    component: LoginPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        //select country based on IP geolocation (web/PWA only — the cordova
        //build serves India and nothing else, so the lookup is skipped)
        if (!isIndiaOnly()) {
          $.getJSON('https://ipapi.co/json/', function(data) {
            var countryCode = data.country_code;
            setCountryCode('countryCode', countryCode);
            setCountryCode('countryCodeReset', countryCode);
          });
        }
        $$('.lgNum').on('click',function(){
          if (!$$('#userLogin')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            login();
          }
        });
        //user login
        function login() {
          var formdata = $('#userLogin').serialize();
          var data = formdata+'&checkLogin=true';
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                localStorage.setItem('phone', data.phone);
                app.popup.open('.sheet-OTP--verification');
                // check if phone is numeric or not
                //mask phone number only show last 4 digits
                if(isNaN(data.phone)) {
                  $$('.otpText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-OTP--verification--phonenumber').html(masked);
                }
              }
              else if(data.code == 'deactivated') {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else if(data.code == 'not-verified') {
                localStorage.setItem('phone', data.phone);
                app.popup.open('.sheet-OTP--verification');
                if(isNaN(data.phone)) {
                  $$('.otpText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-OTP--verification--phonenumber').html(masked);
                }
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        //forget password
        $(document).off('click', '.fpBTN');
        $(document).on('click','.fpBTN',function(){
          if (!$$('#fp-username')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            Forgetpassword();
          }
        });
        function Forgetpassword() {
          var phone = $$('#fp-username').val();
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            {forgetPass: true, mobile: phone, country: $('#countryCodeReset').val()},
            'json',
            function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.close('.sheet-forget--pass');
                app.popup.open('.sheet-forget--otp');
                localStorage.setItem('phone', data.phone);
                if(isNaN(data.phone)) {
                  $$('.resetPassText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-forget--otp--phonenumber').html(masked);
                }
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        //change password
        $(document).off('click', '.fpBTNotp');
        $(document).on('click','.fpBTNotp',function(e){
          e.preventDefault();
          if (!$$('#changePass')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            changePass();
          }
        });
        function changePass() {
          var formdata = $('#changePass').serialize();
          var data = formdata+'&phone='+localStorage.getItem('phone')+'&changePass=true';
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            data,
            'json',
            function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.close('.sheet-forget--otp');
                /* The backend now invalidates the stored token on changePass —
                   signing the user out everywhere. Keeping the old token would
                   make every later call fail with 403 and read as a random
                   logout bug, so drop it and send them to the login screen. */
                clearSession();
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
                setTimeout(function() {
                  app.views.current.router.navigate('/login/', {
                    reloadCurrent: true,
                    ignoreCache: true,
                  });
                }, 1200);
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    path: '/register/referral/:referralCode',
    component: RegisterPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        //get referral code from url
        var referralCode = page.route.params.referralCode;
        $$('#referral').val(referralCode);
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        //date of birth picker (replaces the manual dd/mm/yyyy typing mask)
        //stored on the element so pageBeforeRemove can destroy it
        page.el.f7DobCalendar = createDobCalendar(app, '#dob');
        //user registration
        $$('.btnSignup').on('click',function(){
          if (!$$('#userSignup')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            signup();
          }
        });
        //trim the country lists before select2 renders them
        applyCountryScope();
        $('#country').select2({minimumResultsForSearch: -1, width: '100%', dropdownCssClass: 'ypw-select2-dropdown'});
        //select country based on IP geolocation (web/PWA only)
        if (!isIndiaOnly()) {
          $.getJSON('https://ipapi.co/json/', function(data) {
            var countryCode = data.country_code;
            $('#country').val(countryCode).trigger('change');
            setCountryCode('countryCodeSignup', countryCode);
          });
        }
        $('#gender').select2({minimumResultsForSearch: -1, width: '100%', dropdownCssClass: 'ypw-select2-dropdown'});
        //user signup
        function signup() {
          var formdata = $('#userSignup').serialize();
          var data = formdata+'&userSignup=true';
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                localStorage.setItem('phone',data.phone);
                app.popup.open('.sheet-OTP--verification');
                if(isNaN(data.phone)) {
                  $$('.otpText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-OTP--verification--phonenumber').html(masked);
                }
              }
              else if(data.code == 'exist') {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      },
      pageBeforeRemove: function(e, page) {
        //tear the date picker down with the page that owns it
        if (page.el && page.el.f7DobCalendar) {
          page.el.f7DobCalendar.destroy();
          page.el.f7DobCalendar = null;
        }
      }
    }
  },
  {
    path: '/payment/locker/:id/:type',
    component: PaymentPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        //get locker details from api
        var lockerId = page.route.params.id;
        var type = page.route.params.type;
        if(type == 'subscription') {
          $.getJSON(baseURL+"app/php/lockers.php?getLockerById=true&lockerID="+lockerId+"&token="+localStorage.getItem('authToken'), function() {
            app.dialog.close();
          })
          .done(function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if(data.locker.id == '1') {
                var img = 'assets/icons/gold.png';
                $$('.list-changeValid').removeClass('hidden');
              } else if(data.locker.id == '2') {
                var img = 'assets/icons/platinum.png';
                $$('.list-changeValid').removeClass('hidden');
              }
              else {
                var img = 'assets/icons/diamond.png';
              }
              $$('.locker-media img').attr('src',img);
              $$('.lockerName').html(data.locker.name);
              $$('.lockerPrice').html(INR.format(data.locker.renewalCharge2));
              $$('.lockerValid').html('Validity: 30 Days');
              //order summary
              $$('.lockerPriceO').html(INR2.format(data.locker.renewalCharge2));
              $$('.orderTax').html(INR2.format(data.locker.fee));
              //calculate payable amount
              var total = +data.locker.renewalCharge2 + +data.locker.fee;
              $$('.payableAmount').html(INR2.format(total));
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              //redirect to locker page
              var view = app.views.current;
              view.router.back('/locker/',{force:true});
            }
          })
          .fail(function() {
            app.dialog.close();
            app.toast.show({
              text: 'Something went wrong, please try again!',
              closeTimeout: 3000,
            });
          });
        } else {
          //get subscription details
          app.methods.getUserDataLocker(function(data) {
            if(data.status == 'success') {
              app.dialog.close();
              if(data.subscription.id == '1') {
                var img = 'assets/icons/gold.png';
              } else if(data.subscription.id == '2') {
                var img = 'assets/icons/platinum.png';
              } else {
                var img = 'assets/icons/diamond.png';
              }
              $$('.locker-media img').attr('src',img);
              $$('.lockerName').html(data.subscription.locker+' Plan Renewal');
              $$('.lockerPrice').html(INR.format(data.subscription.price));
              $$('.lockerValid').html('Validity: '+data.subscription.validity+' Days');
              //order summary
              $$('.lockerPriceO').html(INR2.format(data.subscription.price));
              $$('.orderTax').html(INR2.format(data.subscription.fee));
              //calculate payable amount
              var total = +data.subscription.price + +data.subscription.fee;
              $$('.payableAmount').html(INR2.format(total));
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              //redirect to locker page
              var view = app.views.current;
              view.router.back('/locker/',{force:true});
            }
          }
          );
        }
        app.methods.getBank(function(data) {
          if(data.type == 'UPI') {
            $$('.getBankdet').append('<div class="card card-main">\
            <div class="card-content">\
              <div class="list list__loanst">\
                <ul class="color-logo">\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Beneficiary Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.beneficiary+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Bank Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_name+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>Account Number</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_num+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>IFSC Code</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_ifsc+'</div>\
                      </div>\
                    </div>\
                  </li>\
                </ul>\
              </div>\
                <div class="credit-list creditStore text-align-center">\
                  <div class="block text-align-center">\
                    <img src="https://youpaywallet.com/'+data.upi_qrIMG+'" width="150" style="margin-top: 25px;"/>\
                    <div class="item-title text-color-blue"><b>UPI ID: '+data.upi_id+'</b></div>\
                  </div>\
                </div>\
            </div>\
          </div>');
          } else {
            $$('.getBankdet').append('<div class="card card-main">\
            <div class="card-content">\
              <div class="list list__loanst">\
                <ul class="color-logo">\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Beneficiary Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.beneficiary+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Bank Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_name+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>Account Number</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_num+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>IFSC Code</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_ifsc+'</div>\
                      </div>\
                    </div>\
                  </li>\
                </ul>\
              </div>\
            </div>\
          </div>');
          }
        });
        //on change of select box of validity
        $$('.select-valid').on('change', function() {
          var valid = this.value;
          //get locker details from api
          app.dialog.progress('Loading...');
          $.getJSON(baseURL+"app/php/lockers.php?getLockerById=true&lockerID="+lockerId+"&token="+localStorage.getItem('authToken'), function() {
            app.dialog.close();
          })
          .done(function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if(data.locker.id == '1') {
                var img = 'assets/icons/gold.png';
                $$('.list-changeValid').removeClass('hidden');
              } else if(data.locker.id == '2') {
                var img = 'assets/icons/platinum.png';
                $$('.list-changeValid').removeClass('hidden');
              }
              else {
                var img = 'assets/icons/diamond.png';
              }
              $$('.locker-media img').attr('src',img);
              $$('.lockerName').html(data.locker.name);
              if(valid == '30') {
                $$('.lockerPrice').html(INR.format(data.locker.renewalCharge2));
                var renewal = INR2.format(data.locker.renewalCharge2);
                var total = +data.locker.renewalCharge2 + +data.locker.fee;
              } else {
                $$('.lockerPrice').html(INR.format(data.locker.renewalCharge1));
                var renewal = INR2.format(data.locker.renewalCharge1);
                var total = +data.locker.renewalCharge1 + +data.locker.fee;
              }
              $$('.lockerValid').html('Validity: '+valid+' Days');
              //order summary
              $$('.lockerPriceO').html(renewal);
              $$('.orderTax').html(INR2.format(data.locker.fee));
              //calculate payable amount
              $$('.payableAmount').html(INR2.format(total));
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              //redirect to locker page
              var view = app.views.current;
              view.router.back('/locker/',{force:true});
            }
          });
        });
        //upload payment
        $$('#payment').on('change', function() {
          var paymentIMG = $$('#payment').prop('files')[0];
          var validity = $$('.select-valid').val();
          var formData = new FormData();
          if(type == 'subscription') {
            formData.append('subscribe', true);
            formData.append('token', localStorage.getItem('authToken'));
            formData.append('paymentIMG', paymentIMG);
            formData.append('lockerID', lockerId);
            formData.append('validity', validity);
          } else {
            formData.append('renewal', true);
            formData.append('token', localStorage.getItem('authToken'));
            formData.append('paymentIMG', paymentIMG);
          }
          /* Server rules: JPG/PNG/GIF/WEBP only, genuinely decodable, max 5 MB.
             Camera originals routinely exceed that, so catch it before the
             upload rather than after a slow round trip. */
          var uploadError = imageError(this.files[0]);
          if(!$$('#payment')[0].checkValidity()) {
            app.toast.show({
              text: 'Please attach the payment screenshot.',
              closeTimeout: 3000,
            });
          }
          else if(uploadError) {
            app.toast.show({
              text: uploadError,
              closeTimeout: 4000,
            });
          }
          else {
            app.methods.post(
              baseURL+'app/php/lockers.php',
              formData,
              'json',
              function() {
                app.dialog.progress('Loading...');
              },
              function(data) {
                app.dialog.close();
                if(data.status == 'success') {
                  if(type == 'subscription') {
                    $$('.sheet-loan--applied__title').html('Success!');
                    $$('.sheet-loan--applied__text').html('You\'ve successfully requested for a locker subscription, please wait while we\'re verifying your payment.');
                    app.popup.open('.sheet-loan--applied');
                  } else {
                    $$('.sheet-loan--applied__title').html('Success!');
                    $$('.sheet-loan--applied__text').html('You\'ve successfully requested for a locker renewal, please wait while we\'re verifying your payment.');
                    app.popup.open('.sheet-loan--applied');
                  }
                  var view = app.views.current;
                  view.router.back('/',{force:true});
                }
                else {
                  app.toast.show({
                    text: data.msg,
                    closeTimeout: 3000,
                  });
                }
              },
              function() {
                app.dialog.close();
                app.toast.show({
                text: 'Something went wrong, please try again!',
                closeTimeout: 3000,
              });
              }
            );
          }
      });
      }
    }
  },
  {
    path: '/fees/transaction/:txnID',
    component: FeesTransactionPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        //get locker details from api
        var txnID = page.route.params.txnID;
        //last transaction details
        app.methods.request(
          baseURL+'/app/php/lockers.php',
          {getLastWithdrawal: true, token: localStorage.getItem('authToken'), txnID: txnID},
          'json',
          function() { app.dialog.progress('Loading...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if(data.lastWithdrawal) {
                $$('.wamount').html(INR2.format(data.lastWithdrawal.amount));
                $$('.wfee').html(INR2.format(data.lastWithdrawal.withdrawalFee));
                //calculate payable amount
                var total = +data.lastWithdrawal.withdrawalFee;
                $$('.payableAmount').html(INR2.format(total));
              } else {
                console.log('No withdrawal details found.');
              }
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              setTimeout(() => {
                var view = app.views.current;
                view.router.back('/transaction/wallet',{force:true});
              }, 1000);
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
            setTimeout(() => {
              var view = app.views.current;
              view.router.back('/transaction/wallet',{force:true});
            }, 1000);
          }
        );
        app.methods.getBank(function(data) {
          app.dialog.close();
          //bank rows, UPI block and copy buttons, or the
          //no-methods state when neither is configured
          if (!renderBankDetails('.getBankdet', data, baseURL)) {
            $$('.ypw-fees__confirm').addClass('hidden');
          }
        });
        //upload payment
        $$('#payment').on('change', function() {
          var paymentIMG = $$('#payment').prop('files')[0];
          var utr = $$('#utrx').val();
          var validity = $$('.select-valid').val();
          var formData = new FormData();
          formData.append('withdrawalFee', true);
          formData.append('token', localStorage.getItem('authToken'));
          formData.append('paymentIMG', paymentIMG);
          formData.append('txnID', txnID);
          formData.append('utr', utr);
          var uploadError = imageError(this.files[0]);
          var utrProblem = utrError(utr);
          if(!$$('#payment')[0].checkValidity()) {
            app.toast.show({
              text: 'Please attach the payment screenshot.',
              closeTimeout: 3000,
            });
          }
          else if(uploadError) {
            app.toast.show({
              text: uploadError,
              closeTimeout: 4000,
            });
          }
          else if(utrProblem) {
            app.toast.show({
              text: utrProblem,
              closeTimeout: 4000,
            });
          }
          else {
            app.methods.post(
              baseURL+'app/php/lockers.php',
              formData,
              'json',
              function() {
                app.dialog.progress('Loading...');
              },
              function(data) {
                app.dialog.close();
                if(data.status == 'success') {
                  $$('.sheet-loan--applied__title').html('Success!');
                  $$('.sheet-loan--applied__text').html('Your payment is successfully submitted, please wait while we\'re verifying your payment.');
                  app.popup.open('.sheet-loan--applied');
                  var view = app.views.current;
                  view.router.back('/',{force:true});
                }
                else {
                  app.toast.show({
                    text: data.msg,
                    closeTimeout: 3000,
                  });
                }
              },
              function() {
                app.dialog.close();
                app.toast.show({
                text: 'Something went wrong, please try again!',
                closeTimeout: 3000,
              });
              }
            );
          }
      });
      }
    }
  },
  {
    path: '/locker/',
    component: LockerPage,
    name: 'locker',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.dialog.close();
              //get subscription details
              app.methods.getUserDataLocker(function(data) {
                if(data.status == 'success') {
                  $$('.if_locker--locked').addClass('hidden');
                  $$('.toolbar-locker').addClass('hidden');
                  $$('.if_locker--unlocked').removeClass('hidden');
                  $$('.if_locker--unlocked').empty();
                  $$('.if_lockerlist--unlocked').removeClass('hidden');
                  if(data.subscription.id == '1') {
                    var img = 'assets/icons/gold.png';
                  } else if(data.subscription.id == '2') {
                    var img = 'assets/icons/platinum.png';
                  } else {
                    var img = 'assets/icons/diamond.png';
                  }
                  if(data.subscription.status == '0') {
                    var status = 'Pending';
                    var statusColor = 'text-color-orange';
                    var action = 'Please wait while we\'re verifying your payment.';
                    var expire = '';
                    var renew = 'disabled';
                    var renewLink = '';
                  } else if(data.subscription.status == '1') {
                    var status = 'Active';
                    var statusColor = 'text-color-green';
                    var action = 'Your locker is active, you can now use it.';
                    var expire = 'Expires on '+data.subscription.expire;
                    var renew = '';
                    var renewLink = '/payment/locker/'+data.subscription.id+'/renewal';
                  } else {
                    var status = 'Expired';
                    var statusColor = 'text-color-red-deep';
                    var action = 'Your locker is expired, please renew it to use it.';
                    var expire = 'Expired on '+data.subscription.expire;
                    var renew = '';
                    var renewLink = '/payment/locker/'+data.subscription.id+'/renewal';
                  }
                  $$('.if_locker--unlocked').append('<div class="card card-main" style="padding: 5px;">\
                  <div class="card-content">\
                    <div class="list media-list">\
                      <ul class="color-logo">\
                        <li>\
                          <div class="item-link item-content">\
                            <div class="item-media locker-media"><img src="'+img+'" height="80"/></div>\
                            <div class="item-inner">\
                              <div class="item-text text-color-blue fw-600 f-16">'+data.subscription.locker+' Plan</div>\
                              <div class="item-subtitle f-12 '+statusColor+'">'+status+'</div>\
                              <div class="item-text f-12">'+action+'</div>\
                              <div class="item-text f-14 fw-600 '+statusColor+'">'+expire+'</div>\
                              <a href="'+renewLink+'" class="button button-fill button-round margin-top bg-color-red text-color-white button-small w-50 '+renew+'">Renew</a>\
                            </div>\
                          </div>\
                        </li>\
                      </ul>\
                    </div>\
                  </div>\
                  </div>');
                } else {
                  //get locker details from api
                  $.getJSON(baseURL+"app/php/lockers.php?getLocker=true&token="+localStorage.getItem('authToken'), function() {
                    app.dialog.close();
                  })
                  .done(function(data) {
                    app.dialog.close();
                    if(data.status == 'success') {
                      $$('.grid-lockers').empty();
                      //each function
                      $.each(data.lockers, function(i, item) {
                        if(i == 0) {
                          var checked = 'checked';
                        } else {
                          var checked = '';
                        }
                        if(item.id == '1') {
                          var img = 'assets/icons/gold.png';
                          var deposit = INR.format(item.depositLimit);
                        } else if(item.id == '2') {
                          var img = 'assets/icons/platinum.png';
                          var deposit = INR.format(item.depositLimit);
                        } else {
                          var img = 'assets/icons/diamond.png';
                          var deposit = 'Unlimited';
                        }
                        $$('.grid-lockers').append('<label class="card-lockers">\
                        <input name="plan" class="radio" type="radio" '+checked+' value="'+item.id+'">\
                        <span class="plan-details">\
                          <img src="'+img+'" width="100" class="m-auto"/>\
                          <span class="plan-type margin-top">'+item.name+'</span>\
                          <span class="plan-cost text-color-blue">'+INR.format(item.renewalCharge2)+'<span class="slash">/</span><abbr class="plan-cycle" title="month">month</abbr></span>\
                          <span class="text-color-blue f-14 text-align-justify display-flex flex-direction-column locker-details">\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.maximumAC+' Virtual A/C</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+deposit+' Deposit Limit Daily</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.withdrawalLimit+' Withdrawal Request Daily</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.withdrawalFee+'% Withdrawal Charge</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.return+'% Cashback on Withdrawal Charge</span>\
                          </span>\
                        </span>\
                      </label>');
                      });
                    }
                  })
                  .fail(function() {
                    app.dialog.close();
                    app.toast.show({
                      text: 'Something went wrong, please try again!',
                      closeTimeout: 3000,
                    });
                  });
                }
              });
            } else {
              app.dialog.close();
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        //locker submit
        $$('.subscribe-locker').on('click', function() { 
          //get selected locker
          var locker = $$('.radio:checked').val();
          //redirect to payment page
          app.views.main.router.navigate('/payment/locker/'+locker+'/subscription');
        });
      }
    }
  },
  {
    /* Prepaid, postpaid and DTH share one component; :type selects the copy,
       the operator list and the validation rules.

       The submit posts to app/php/recharge.php, which does not exist yet --
       no biller is integrated. Until it does, the request fails and the user
       is told so rather than being shown a fake success. The payload is:

         { recharge: true, token, type, operator, circle, number, amount }

       and a success response is expected to look like the other endpoints:
         {
    /* Prepaid, postpaid and DTH share one component; :type selects the copy
       and which operator list is fetched.

       Everything variable comes from the backend (see API-RECHARGE.md):
       operators, circles, per-operator number lengths, per-operator amount
       bounds and needsCircle. None of it is hard-coded, because operator
       master data is editable in the admin panel and DTH subscriber-id length
       differs per operator (10 for Tata Play / Airtel, 11 for Dish TV / Sun
       Direct). */
    path: '/recharge/:type',
    beforeEnter: requireSignIn,
    component: RechargePage,
    name: 'recharge',
    on: {
      /* The smart-select builds a popup outside this page, so it has to be
         torn down with the page rather than left behind. */
      pageBeforeRemove: function(e, page) {
        var picker = page.el.__circlePicker;
        if (picker && picker.destroy) picker.destroy();
        page.el.__circlePicker = null;
      },
      pageInit: function(e, page) {
        var app = this.app;
        /* Scoped to THIS page: all three modes share one component, so during a
           mobile -> postpaid transition both pages are in the DOM and a
           document-wide lookup finds the outgoing one. */
        var $page = $$(page.el);

        /* The URL says `mobile` because that is what the tile is called; the
           API's canonical value is `prepaid`. */
        var ROUTE_TO_SERVICE = { mobile: 'prepaid', prepaid: 'prepaid', postpaid: 'postpaid', dth: 'dth' };
        var routeType = (page.route.params.type || 'mobile').toLowerCase();
        var service = ROUTE_TO_SERVICE[routeType] || 'prepaid';

        var MODES = {
          prepaid: {
            title: 'Mobile Recharge', numberLabel: 'Mobile number',
            numberPlaceholder: '10-digit mobile number',
            amountLabel: 'Recharge amount', prefix: '+91'
          },
          postpaid: {
            title: 'Postpaid Bill', numberLabel: 'Postpaid number',
            numberPlaceholder: '10-digit mobile number',
            amountLabel: 'Bill amount', prefix: '+91'
          },
          dth: {
            title: 'DTH Recharge', numberLabel: 'Subscriber ID',
            numberPlaceholder: 'Subscriber / customer ID',
            amountLabel: 'Recharge amount', prefix: ''
          }
        };
        var mode = MODES[service];

        $page.find('.ypw-recharge__title').text(mode.title);
        $page.find('.ypw-recharge__numlabel').text(mode.numberLabel);
        $page.find('.ypw-recharge__amtlabel').text(mode.amountLabel);
        $page.find('#rcNumber').attr('placeholder', mode.numberPlaceholder);
        if (mode.prefix) $page.find('.ypw-recharge__prefix').text(mode.prefix);
        else $page.find('.ypw-recharge__prefix').remove();

        var formEl = $page.find('#rechargeForm')[0];
        var gridEl = $page.find('#rcOperatorGrid')[0];
        var circleField = $page.find('.ypw-recharge__circle');
        var circleEl = $page.find('#rcCircle')[0];
        var numberEl = $page.find('#rcNumber')[0];
        var amountEl = $page.find('#rcAmount')[0];
        var operatorEl = $page.find('#rcOperator')[0];
        var payFromEl = $page.find('#rcPayFrom')[0];
        var submitEl = $page.find('.rechargeBtn')[0];

        var operators = [];
        var selectedOperator = null;
        var walletBalance = 0;
        var cashbackBalance = 0;
        var submitting = false;

        /* "Repeat recharge" from transaction history. The number and amount
           go in now; the operator and circle once their lists arrive, matched
           by name -- that is what a history row carries. One that has since
           been renamed or switched off is simply left for the customer. */
        var repeat = takeRepeat('recharge');
        if (repeat && repeat.service !== service) repeat = null;
        if (repeat) {
          numberEl.value = repeat.number || '';
          amountEl.value = repeat.amount ? String(+repeat.amount) : '';
          app.toast.show({ text: 'Filled in from your earlier recharge. Check the details, then pay.', closeTimeout: 3500 });
        }
        function sameName(a, b) {
          return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
        }
        function applyRepeatOperator() {
          if (!repeat || !repeat.operator) return;
          operators.forEach(function(op) {
            if (sameName(op.name, repeat.operator)) selectOperator(op.code);
          });
        }
        function applyRepeatCircle() {
          if (!repeat || !repeat.circle) return;
          for (var i = 0; i < circleEl.options.length; i += 1) {
            if (sameName(circleEl.options[i].textContent, repeat.circle)) {
              circleEl.selectedIndex = i;
              paintCircleValue();
              return;
            }
          }
        }

        /* Local artwork for the seeded operator codes. The admin panel can
           rename `code` at any time, so this is matched loosely on code AND
           name and is only a fallback: an `icon` supplied by the API wins. */
        var LOCAL_ICONS = {
          airtel: 'airtel.png', airtelin: 'airtel.png',
          jio: 'jio.png', reliancejio: 'jio.png',
          vi: 'vi.png', vodafone: 'vi.png', idea: 'vi.png', vodafoneidea: 'vi.png',
          bsnl: 'bsnl.png', mtnl: 'mtnl.png',
          tataplay: 'tata-play.png', tatasky: 'tata-play.png',
          airteltv: 'airteltv.png', airteldth: 'airteltv.png', airteldigitaltv: 'airteltv.png',
          dishtv: 'dishtv.png', dish: 'dishtv.png',
          d2h: 'd2h.png', videocond2h: 'd2h.png',
          sundirect: 'sun-direct.png'
        };

        function normalise(value) {
          return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        }

        /* Longest first, so "airteldigitaltv" is tested before "airtel" and a
           DTH row cannot pick up the mobile logo. */
        var ICON_KEYS = Object.keys(LOCAL_ICONS).sort(function(a, b) {
          return b.length - a.length;
        });

        /* Postpaid rows are separate rows in the same table and need their own
           unique code, so they arrive as AIRTEL_POST / "Airtel Postpaid" and
           match no brand key exactly. Strip the service qualifier and retry. */
        function withoutService(value) {
          return value.replace(/(postpaid|prepaid|post|pre|bill|payment|recharge|mobile)/g, '');
        }

        function iconFor(op) {
          if (op.icon) return baseURL + op.icon;

          var code = normalise(op.code);
          var name = normalise(op.name);

          var file = LOCAL_ICONS[code] || LOCAL_ICONS[name] ||
            LOCAL_ICONS[withoutService(code)] || LOCAL_ICONS[withoutService(name)];

          if (!file) {
            /* Last resort: brand name embedded in something longer. Keys under
               four characters are excluded -- "vi" appears inside plenty of
               unrelated words, and it is already covered above. */
            for (var i = 0; i < ICON_KEYS.length; i += 1) {
              var key = ICON_KEYS[i];
              if (key.length < 4) continue;
              if (code.indexOf(key) >= 0 || name.indexOf(key) >= 0) {
                file = LOCAL_ICONS[key];
                break;
              }
            }
          }

          return file ? 'assets/operators/' + file : '';
        }

        function money(value) {
          return INR2.format(parseFloat(value) || 0);
        }

        /* ---------------------------------------------------------- chips -- */

        function renderOperators() {
          $$(gridEl).empty();
          if (!operators.length) {
            $$(gridEl).append('<p class="ypw-recharge__empty">No operators are available right now.</p>');
            return;
          }
          operators.forEach(function(op) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'ypw-opr no-ripple';
            chip.setAttribute('data-code', op.code);
            var art = iconFor(op);
            if (art) {
              var img = document.createElement('img');
              img.className = 'ypw-opr__logo';
              img.setAttribute('src', art);
              img.setAttribute('alt', '');
              /* A renamed operator can point at artwork that is not there.
                 Drop the image rather than leave a broken-image glyph sitting
                 next to the name. */
              img.onerror = function() {
                if (this.parentNode) this.parentNode.removeChild(this);
              };
              chip.appendChild(img);
            }
            var label = document.createElement('span');
            label.className = 'ypw-opr__name';
            label.textContent = op.name;
            chip.appendChild(label);
            gridEl.appendChild(chip);
          });
        }

        function selectOperator(code) {
          selectedOperator = null;
          operators.forEach(function(op) { if (op.code === code) selectedOperator = op; });
          $$(gridEl).find('.ypw-opr').removeClass('is-selected');
          $$(gridEl).find('.ypw-opr[data-code="' + code + '"]').addClass('is-selected');

          operatorEl.value = code;
          operatorEl.setCustomValidity('');
          $$(operatorEl).parents('.ypw-field').removeClass('is-invalid');

          if (!selectedOperator) return;

          /* needsCircle is per operator, not per service */
          if (String(selectedOperator.needsCircle) === '1') {
            circleField.removeClass('hidden');
            circleEl.setAttribute('required', 'required');
          } else {
            circleField.addClass('hidden');
            circleEl.removeAttribute('required');
            circleEl.value = '';
            circleEl.setCustomValidity('');
            circleField.removeClass('is-invalid');
          }

          var min = parseFloat(selectedOperator.minAmount);
          var max = parseFloat(selectedOperator.maxAmount);
          $page.find('.ypw-recharge__bounds').text(
            (isNaN(min) || isNaN(max)) ? '' : 'Between ' + money(min) + ' and ' + money(max)
          );

          //the accepted id length changed with the operator, so re-check it
          if (numberEl.value) numberEl.setCustomValidity('');
        }

        /* ------------------------------------------------------ master data -- */

        function loadOperators() {
          $.getJSON(
            baseURL + 'app/php/recharge.php?getOperators=1&type=' + encodeURIComponent(service) +
            '&token=' + encodeURIComponent(localStorage.getItem('authToken')),
            function() {}
          )
          .done(function(data) {
            if (data && data.status === 'success' && data.operators) {
              operators = data.operators.filter(function(op) {
                //an untyped list came back: keep only this service's rows
                return !op.type || op.type === service;
              });
            } else {
              operators = [];
            }
            renderOperators();
            applyRepeatOperator();
          })
          .fail(function() {
            operators = [];
            renderOperators();
            app.toast.show({ text: 'Could not load operators, please try again.', closeTimeout: 3000 });
          });
        }

        var circlePicker = null;

        function paintCircleValue() {
          var $value = $page.find('#rcCircleValue');
          var option = circleEl.options[circleEl.selectedIndex];
          if (option && circleEl.value) {
            $value.text(option.textContent).removeClass('is-placeholder');
          } else {
            $value.text('Select circle').addClass('is-placeholder');
          }
        }

        function initCirclePicker(page) {
          if (circlePicker) return;
          circlePicker = app.smartSelect.create({
            el: $page.find('#rcCirclePicker')[0],
            valueEl: $page.find('#rcCircleValue')[0],
            openIn: 'sheet',
            /* F7's own sheet markup is a bare toolbar with a Done link and no
               title or searchbar, which is a poor fit for 23 circles. This is
               the supported override, and onOpen still finds the .searchbar
               and .smart-select-list-* it expects, so search keeps working. */
            renderSheet: function(items) {
              var ss = this;
              return '' +
                '<div class="sheet-modal smart-select-sheet ypw-smart ypw-picker"' +
                    ' data-select-name="' + ss.selectName + '">' +
                  '<div class="ypw-picker__head">' +
                    '<span class="ypw-picker__grip"></span>' +
                    '<div class="ypw-picker__row">' +
                      '<h2 class="ypw-picker__title">' + ss.params.pageTitle + '</h2>' +
                      '<a href="#" class="ypw-picker__close sheet-close no-ripple" aria-label="Close">' +
                        '<svg class="ypw-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6.5 6.5 11 11M17.5 6.5l-11 11"/></svg>' +
                      '</a>' +
                    '</div>' +
                    ss.renderSearchbar() +
                  '</div>' +
                  '<div class="sheet-modal-inner">' +
                    '<div class="page-content">' +
                      '<div class="list smart-select-list-' + ss.id + '">' +
                        '<ul>' + ss.renderItems(items) + '</ul>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>';
            },
            pageTitle: 'Select circle',
            /* Passed as an object, not `true`: Searchbar defaults to
               disableButton, and smart-select only renders that button when
               searchbarDisableButton is set. Enabling one without the other
               makes Searchbar.create throw -- and because it is created before
               attachInputsEvents() in onOpen, the whole list stops responding
               to taps. */
            searchbar: { disableButton: false },
            searchbarPlaceholder: 'Search circle',
            closeOnSelect: true,
            /* Off until something IS selected. F7's scrollToSelectedItem does
               $containerEl.find('input:checked').parents('li').offset().top,
               and with no selection offset() is null -- it throws inside
               onOpen, before attachInputsEvents(), leaving a list that ignores
               every tap. Turned on in the change handler below. */
            scrollToSelectedItem: false,
            /* the picker is a detail of this field, not a place to navigate
               back to -- pushState is on, so a routable modal would put it in
               the history stack */
            routableModals: false,
            cssClass: 'ypw-smart',
            on: {
              /* The smart select's own event, not the <select>'s: F7 writes
                 into valueEl after the select fires change, so hooking the
                 select alone left the placeholder styling stale. */
              change: function() {
                circleEl.setCustomValidity('');
                $$(circleEl).parents('.ypw-field').removeClass('is-invalid');
                paintCircleValue();
                //now that a row is checked, reopening can safely scroll to it
                if (circlePicker) circlePicker.params.scrollToSelectedItem = true;
              }
            }
          });
          //also covers a value set on the <select> by anything other than F7
          $$(circleEl).on('change', function() {
            this.setCustomValidity('');
            $$(this).parents('.ypw-field').removeClass('is-invalid');
            paintCircleValue();
          });
          //so pageBeforeRemove can tear the picker (and its popup) down
          page.el.__circlePicker = circlePicker;
        }

        function loadCircles() {
          $.getJSON(
            baseURL + 'app/php/recharge.php?getCircles=1&token=' +
            encodeURIComponent(localStorage.getItem('authToken')),
            function() {}
          )
          .done(function(data) {
            if (!data || data.status !== 'success' || !data.circles) return;
            $$(circleEl).empty();
            data.circles.forEach(function(circle) {
              //the backend accepts id, code or name; code is the stable one
              circleEl.appendChild(new Option(circle.name, circle.code));
            });
            /* No placeholder option, so nothing is chosen yet -- a select with
               options otherwise reports its first one as selected and would
               satisfy `required` without the user picking anything. */
            circleEl.selectedIndex = -1;
            initCirclePicker(page);
            paintCircleValue();
            applyRepeatCircle();
          });
        }

        function loadBalances() {
          app.methods.getUserDataLocker(function(data) {
            app.dialog.close();
            if (data.status == 'success') {
              walletBalance = parseFloat(data.subscription.wallet) || 0;
              cashbackBalance = parseFloat(data.subscription.cashbackWallet) || 0;
              paintBalances();
            } else {
              app.toast.show({ text: data.msg, closeTimeout: 3000 });
            }
          });
        }

        function paintBalances() {
          $page.find('.wallet--amount').html(money(walletBalance));
          $page.find('.cashback--amount').html(money(cashbackBalance));
        }

        app.dialog.progress('Loading...');
        loadOperators();
        loadCircles();
        loadBalances();

        /* ----------------------------------------------------- interaction -- */

        formEl.addEventListener('click', function(ev) {
          var chip = ev.target.closest('.ypw-opr');
          if (chip) {
            ev.preventDefault();
            selectOperator(chip.getAttribute('data-code'));
            return;
          }
          var amountChip = ev.target.closest('.ypw-chip');
          if (amountChip) {
            ev.preventDefault();
            amountEl.value = amountChip.getAttribute('data-amount');
            amountEl.setCustomValidity('');
            $$(amountEl).parents('.ypw-field').removeClass('is-invalid');
            return;
          }
          var payOpt = ev.target.closest('.ypw-payfrom__opt');
          if (payOpt) {
            ev.preventDefault();
            $$(formEl).find('.ypw-payfrom__opt').removeClass('is-selected');
            $$(payOpt).addClass('is-selected');
            payFromEl.value = payOpt.getAttribute('data-payfrom');
            amountEl.setCustomValidity('');
          }
        });

        formEl.addEventListener('input', function(ev) {
          if (ev.target.setCustomValidity) ev.target.setCustomValidity('');
        });

        /* ---------------------------------------------------------- submit -- */

        function spendableTotal() {
          var from = payFromEl.value;
          if (from === 'cashback') return cashbackBalance;
          if (from === 'both') return walletBalance + cashbackBalance;
          return walletBalance;
        }

        function amountProblem(amount) {
          if (!amountEl.value.trim() || isNaN(amount)) return 'Enter an amount';
          if (!/^\d+(\.\d{1,2})?$/.test(amountEl.value.trim())) {
            return 'Amount can have at most 2 decimal places';
          }
          if (selectedOperator) {
            var min = parseFloat(selectedOperator.minAmount);
            var max = parseFloat(selectedOperator.maxAmount);
            if (!isNaN(min) && amount < min) return 'Minimum for this operator is ' + money(min);
            if (!isNaN(max) && amount > max) return 'Maximum for this operator is ' + money(max);
          }
          if (amount > spendableTotal()) {
            var from = payFromEl.value;
            if (from === 'cashback') return 'More than your cashback balance of ' + money(cashbackBalance);
            if (from === 'both') return 'More than your combined balance of ' + money(spendableTotal());
            return 'More than your wallet balance of ' + money(walletBalance);
          }
          return '';
        }

        function numberProblem(value) {
          if (!value) return service === 'dth' ? 'Enter the subscriber ID' : 'Enter the mobile number';
          if (service === 'dth') {
            /* Length comes from the operator: Tata Play and Airtel Digital TV
               are 10, Dish TV and Sun Direct are 11. */
            var lo = selectedOperator ? parseInt(selectedOperator.numberMin, 10) : NaN;
            var hi = selectedOperator ? parseInt(selectedOperator.numberMax, 10) : NaN;
            if (!/^[0-9A-Za-z]+$/.test(value)) return 'Enter a valid subscriber ID';
            if (!isNaN(lo) && !isNaN(hi)) {
              if (value.length < lo || value.length > hi) {
                return lo === hi
                  ? 'This operator uses ' + lo + '-digit subscriber IDs'
                  : 'Subscriber ID must be ' + lo + ' to ' + hi + ' characters';
              }
            }
            return '';
          }
          return /^[6-9][0-9]{9}$/.test(value) ? '' : 'Enter a valid 10-digit mobile number';
        }

        function setSubmitting(state) {
          submitting = state;
          $$(submitEl)[state ? 'addClass' : 'removeClass']('disabled');
        }

        formEl.addEventListener('submit', function(ev) {
          ev.preventDefault();
          /* The backend rejects a repeat of the same service + number + amount
             within 120 s, so a double tap must never reach it. */
          if (submitting) return;

          var value = numberEl.value.trim();
          numberEl.setCustomValidity(numberProblem(value));
          amountEl.setCustomValidity(amountProblem(parseFloat(amountEl.value)));
          if (circleEl.hasAttribute('required') && !circleEl.value) {
            circleEl.setCustomValidity('Select a circle');
          } else {
            circleEl.setCustomValidity('');
          }

          if (!validateScope(formEl)) return;

          var formData = app.form.convertToData(formEl);
          formData.recharge = true;
          formData.type = service;
          formData.token = localStorage.getItem('authToken');
          if (!circleEl.hasAttribute('required')) delete formData.circle;

          setSubmitting(true);
          app.dialog.progress('Processing...');
          app.methods.request(
            baseURL + '/app/php/recharge.php',
            formData,
            'json',
            function() {},
            function(data) {
              app.dialog.close();
              setSubmitting(false);
              handleRechargeReply(data);
            },
            function() {
              app.dialog.close();
              setSubmitting(false);
              app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 });
            }
          );
        });

        /* -------------------------------------------------------- outcome -- */

        function handleRechargeReply(data) {
          if (!data) {
            app.toast.show({ text: 'Something went wrong, please try again!', closeTimeout: 3000 });
            return;
          }

          /* A validation error has no `recharge` block. A recharge that failed
             at the provider has one, with the money already refunded -- the
             request itself was processed correctly. */
          if (!data.recharge) {
            /* kyc_required / wallet_limit: over the monthly spending limit */
            if (walletRefusal(app, data)) return;
            app.toast.show({ text: data.msg || 'Could not place this recharge.', closeTimeout: 4000 });
            return;
          }

          //the top-level pair is the balance NOW, after any automatic refund
          if (data.walletBalance !== undefined) walletBalance = parseFloat(data.walletBalance) || 0;
          if (data.cashbackBalance !== undefined) cashbackBalance = parseFloat(data.cashbackBalance) || 0;
          paintBalances();

          showOutcome(data.recharge);

          var status = String(data.recharge.status);
          if (status === '0' || status === '3') pollStatus(data.recharge.txnID, 0);
          else {
            formEl.reset();
            /* form.reset() restores each control to its default, and a select
               with no `selected` option defaults to its FIRST one -- which
               would silently re-arm the circle. */
            circleEl.selectedIndex = -1;
            paintCircleValue();
            $$(gridEl).find('.ypw-opr').removeClass('is-selected');
            selectedOperator = null;
            payFromEl.value = 'wallet';
            $$(formEl).find('.ypw-payfrom__opt').removeClass('is-selected');
            $$(formEl).find('.ypw-payfrom__opt[data-payfrom="wallet"]').addClass('is-selected');
          }
        }

        function showOutcome(recharge) {
          var status = String(recharge.status);
          var who = recharge.number || '';
          var amount = money(recharge.amount);
          var title;
          var text;

          if (status === '1') {
            title = amount + ' Recharge Successful!';
            text = recharge.serviceLabel + ' for ' + who + ' via ' + recharge.operator + ' was successful.';
          } else if (status === '2') {
            /* Money is already back, and back in the wallets it came from. */
            title = 'Recharge Failed';
            text = (recharge.remarks && recharge.remarks !== 'N/A' ? recharge.remarks + ' ' : '') +
              'The full ' + amount + ' has been refunded to your wallet.';
          } else {
            /* 0 Pending and 3 Processing are both "not finished". Never call
               these a failure: the operator may well have delivered. */
            title = amount + ' Recharge Submitted';
            text = recharge.serviceLabel + ' for ' + who + ' is being processed. ' +
              'We will update this as soon as the operator confirms.';
          }

          $$('.sheet-loan--applied__title').html(title);
          $$('.sheet-loan--applied__text').html(text);
          $$('.sheet-loan--applied').removeClass('is-failed is-pending');
          if (status === '2') $$('.sheet-loan--applied').addClass('is-failed');
          else if (status !== '1') $$('.sheet-loan--applied').addClass('is-pending');
          app.popup.open('.sheet-loan--applied');
        }

        /* Re-checks an unsettled order. Rate limited to 60/hour server-side,
           so this backs off and gives up rather than polling forever. */
        function pollStatus(txnID, attempt) {
          if (!txnID || attempt >= 6) return;
          if (!$$('.sheet-loan--applied').hasClass('modal-in')) return;

          setTimeout(function() {
            if (!$$('.sheet-loan--applied').hasClass('modal-in')) return;
            app.methods.request(
              baseURL + '/app/php/recharge.php',
              { rechargeStatus: true, txnID: txnID, token: localStorage.getItem('authToken') },
              'json',
              function() {},
              function(data) {
                if (!data || !data.recharge) return;
                if (data.walletBalance !== undefined) walletBalance = parseFloat(data.walletBalance) || 0;
                if (data.cashbackBalance !== undefined) cashbackBalance = parseFloat(data.cashbackBalance) || 0;
                paintBalances();

                var status = String(data.recharge.status);
                if (status === '0' || status === '3') {
                  pollStatus(txnID, attempt + 1);
                } else {
                  showOutcome(data.recharge);
                }
              },
              function() { /* a failed poll is not a failed recharge */ }
            );
          }, 4000 + attempt * 2000);
        }
      }
    }
  },
  {
    /* Static catalogue: no biller is integrated yet, so there is nothing
       to fetch and no session guard to run. */
    path: '/services/',
    component: ServicesPage,
    name: 'services',
  },
  {
    path: '/deposit/',
    component: DepositPage,
    name: 'deposit',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var $page = $(page.el);
        app.dialog.progress('Loading...');
        var country = localStorage.getItem('country');
        if(country == 'IN') {
          $$('.not-available').addClass('hidden');
        } else {
          $$('.available').addClass('hidden');
        }
        //get subscription details
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if (data.status !== 'success') {
            app.toast.show({ text: data.msg, closeTimeout: 3000 });
            return;
          }
          renderDepositAccounts(data);
        });
        /* The strip names the limit that applies, not just the daily one:
           without KYC the monthly limit on money added (userinfo) is the
           tighter. See depositAllowance() in kyc.js. */
        var depositDaily = NaN;
        function paintDepositStrip() {
          var rule = depositAllowance(depositDaily);
          $page.find('.ypw-limit__label').text(rule ? rule.label : 'Daily deposit limit');
          $page.find('.depositLimit').text(rule ? INR.format(rule.max) : 'Unlimited');
        }
        app.methods.getUserData(function() { paintDepositStrip(); });

        /*
         * accounts[] now mixes the locker's own bank accounts with the company
         * deposit account, and each entry is method:"bank" or method:"upi".
         * A UPI entry rendered as a bank card is four blank rows, so the two
         * are drawn differently.
         */
        function renderDepositAccounts(data) {
          var accounts = Array.isArray(data.accounts) ? data.accounts : [];
          var list = $page.find('.ypw-deposit__list');
          list.empty();

          if (!accounts.length) {
            $page.find('.ypw-deposit__empty').removeClass('hidden');
            $page.find('.ypw-limit').addClass('hidden');
            $page.find('.ypw-deposit__heading').addClass('hidden');
            return;
          }
          $page.find('.ypw-deposit__empty').addClass('hidden');
          $page.find('.ypw-deposit__heading').removeClass('hidden');

          depositDaily = parseFloat(data.subscription && data.subscription.depositLimit);
          $page.find('.ypw-limit').removeClass('hidden');
          paintDepositStrip();

          var BANK_ICON = '<svg class="ypw-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 9.5h17"/><path d="M12 3.2 21 8.2H3l9-5Z"/><path d="M6.5 10v6.5M10.5 10v6.5M13.5 10v6.5M17.5 10v6.5"/><path d="M3 20.2h18"/></svg>';
          var UPI_ICON = '<svg class="ypw-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><path d="M13.5 13.5h3v3h-3zM20.5 20.5h-3v-3"/></svg>';
          var GO_ICON = '<svg class="ypw-ic ypw-row__go" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9.5 5.5 6.5 6.5-6.5 6.5"/></svg>';

          /* Enough to tell two accounts apart without printing the whole
             number on a screen someone may be showing to a shopkeeper. */
          function maskedAccount(value) {
            var digits = String(value || '');
            if (digits.length <= 4) return digits;
            return '\u2022\u2022\u2022\u2022 ' + digits.slice(-4);
          }

          accounts.forEach(function(account) {
            var upi = String(account.method) === 'upi';

            var row = document.createElement('a');
            row.className = 'ypw-row no-ripple';
            /* The id is used exactly as received: company entries carry large
               ids (900004, 950004) so a locker account and a settings row can
               never collide. Deriving one would file the deposit against a
               different account than the one chosen. */
            row.setAttribute('href', '/deposit-money/account/' + account.id);

            var tile = document.createElement('span');
            tile.className = 'ypw-tile ypw-tile--sm' + (upi ? ' ypw-tile--brand' : '');
            tile.innerHTML = upi ? UPI_ICON : BANK_ICON;
            row.appendChild(tile);

            var body = document.createElement('span');
            body.className = 'ypw-row__body';

            var title = document.createElement('span');
            title.className = 'ypw-row__title';
            title.textContent = account.label || account.bankName || account.upiName || 'Deposit account';

            var sub = document.createElement('span');
            sub.className = 'ypw-row__sub';
            sub.textContent = upi ? (account.upiID || 'Pay by UPI')
                                  : maskedAccount(account.bankAC);

            body.appendChild(title);
            body.appendChild(sub);
            row.appendChild(body);

            var badge = document.createElement('span');
            badge.className = 'ypw-row__badge' + (upi ? ' ypw-row__badge--upi' : '');
            badge.textContent = upi ? 'UPI' : 'Bank';
            row.appendChild(badge);

            row.insertAdjacentHTML('beforeend', GO_ICON);
            list.append(row);
          });
        }
      }
    }
  },
  {
    path: '/deposit-money/:account/:accountID',
    component: DepositMoneyPage,
    name: 'deposit-money',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var accountID = page.route.params.accountID;
        //"Deposit again" from transaction history (it went through the
        //account list first, so it is picked up here)
        var repeat = takeRepeat('deposit');
        if (repeat && repeat.amount) {
          $$(page.el).find('#amount').val(String(+repeat.amount));
        }
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        //get account details by accountID
        $.getJSON(baseURL+"app/php/lockers.php?getAccountByID=true&accountID="+accountID+"&token="+localStorage.getItem('authToken'), function() {
          app.dialog.close();
        })
        .done(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            /* Branches on method, so a UPI account shows its merchant name,
               UPI ID and QR rather than four empty bank rows. */
            renderDepositAccount('.getDepositAccount', data.account);
            /* Post back the id exactly as received -- company entries carry
               large ids so they cannot collide with locker ones. */
            $('input[name="accountID"]').val(data.account.id);
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to locker page
            var view = app.views.current;
            view.router.back('/deposit/',{force:true});
          }
        })
        .fail(function() {
          app.dialog.close();
          app.toast.show({
            text: 'Something went wrong, please try again!',
            closeTimeout: 3000,
          });
        });
        /* The most this deposit can be: the tighter of the wallet limits by
           KYC level (from userinfo -- ₹10,000 a month without KYC) and the
           daily deposit limit (subscribeInfo -> depositLimit). Both are read
           afresh each time; see depositAllowance() in kyc.js. Deposits still
           being verified count on the server only, so this is a ceiling the
           app can check before uploading the screenshot. */
        var depositDaily = NaN;
        var depositRule = null;
        function paintDepositLimit() {
          depositRule = depositAllowance(depositDaily);
          var hint = $$(page.el).find('.depositLimitHint');
          if (!depositRule) { hint.addClass('hidden'); return; }
          $$(page.el).find('#amount').attr('max', depositRule.max);
          hint.html(depositRule.hint).removeClass('hidden');
        }
        app.methods.getUserDataLocker(function(data) {
          if (data.status != 'success' || !data.subscription) return;
          depositDaily = parseFloat(data.subscription.depositLimit);
          paintDepositLimit();
        });
        //userinfo carries the monthly figures; getUserData records them first
        app.methods.getUserData(function() { paintDepositLimit(); });
        //upload deposit receipt
        $$('.depositMoney').on('click', function() {
          var depositIMG = $$('#depositReceipt').prop('files')[0];
          var utr = $$('#utr').val();
          var formData = new FormData();
          formData.append('deposit', true);
          formData.append('token', localStorage.getItem('authToken'));
          formData.append('depositIMG', depositIMG);
          /* Only ever send an id the server already confirmed belongs to this
             locker (set from getAccountByID above); an arbitrary or stale id
             is now rejected outright. */
          formData.append('accountID', $$('input[name="accountID"]').val() || accountID);
          formData.append('utr', utr);
          formData.append('amount', $$('#amount').val());
          if(!$$('#amount')[0].checkValidity()) {
            app.toast.show({
              text: 'Please enter your deposit amount!',
              closeTimeout: 3000,
            });
          }
          //over the limit that applies: say so now, with the KYC offer where
          //KYC would raise it, rather than after uploading the screenshot
          else if(depositRule && parseFloat($$('#amount').val()) > depositRule.max) {
            depositRefusal(app, depositRule);
          }
          else if(utrError(utr)) {
            app.toast.show({
              text: utrError(utr),
              closeTimeout: 4000,
            });
          }
          else if(!$$('#depositReceipt')[0].checkValidity()) {
            app.toast.show({
              text: 'Please attach the deposit receipt.',
              closeTimeout: 3000,
            });
          }
          else {
            var uploadError = imageError($$('#depositReceipt').prop('files')[0]);
            if (uploadError) {
              app.toast.show({
                text: uploadError,
                closeTimeout: 4000,
              });
            } else {
              app.methods.post(
                baseURL+'app/php/lockers.php',
                formData,
                'json',
                function() {
                  app.dialog.progress('Loading...');
                },
                function(data) {
                  app.dialog.close();
                  if(data.status == 'success') {
                    app.popup.open('.sheet-loan--applied');
                    $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Deposit Requested!');
                    $$('.sheet-loan--applied__text').html('Your wallet balance will be updated once we verify your deposit, please wait while we\'re verifying your deposit.');
                    var view = app.views.current;
                    view.router.back('/',{force:true});
                  }
                  //over a wallet limit, or one KYC would raise
                  else if(!walletRefusal(app, data)) {
                    app.toast.show({
                      text: data.msg,
                      closeTimeout: 3000,
                    });
                  }
                },
                function() {
                  app.dialog.close();
                  app.toast.show({
                  text: 'Something went wrong, please try again!',
                  closeTimeout: 3000,
                });
                }
              );
            }
          }
        });
      }
    }
  },
  {
    path: '/withdraw/',
    //a minimum-KYC wallet cannot withdraw: explain and offer KYC instead
    beforeEnter: walletGate('withdraw'),
    component: TransferPage,
    name: 'transfer',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        //renders the selected beneficiary read-back
        function renderBeneficiaryCard(sel) {
          var rows = [
            ['Beneficiary', sel.data('beneficiary')],
            ['Bank', sel.data('bankname')],
            ['Account number', sel.val()],
            ['IFSC / SWIFT', sel.data('ifsc')],
            ['Phone', sel.data('receiverphone')],
            ['Email', sel.data('receiveremail')]
          ];
          var box = $('.block-beneficiaryDetails');
          box.empty();
          box.append('<div class="ypw-payee-card"></div>');
          var card = box.find('.ypw-payee-card')[0];
          rows.forEach(function(row) {
            var value = row[1];
            if (value === undefined || value === null) return;
            value = String(value).trim();
            if (!value || value === 'undefined' || value === 'null') return;
            var line = document.createElement('div');
            line.className = 'ypw-payee-card__row';
            var k = document.createElement('span');
            k.textContent = row[0];
            var v = document.createElement('b');
            v.textContent = value;
            line.appendChild(k);
            line.appendChild(v);
            card.appendChild(line);
          });
        }
        app.dialog.progress('Loading...');
        //get subscription details
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            $$('.wallet--amount').html(INR2.format(data.subscription.wallet));
            $$('input[name="fee"]').val(data.subscription.withdrawalFee);
            $$('input[name="wallet"]').val(data.subscription.wallet);
            /* The amount is capped by the per-withdrawal limit as well as the
               balance. Both come from subscribeInfo every time this opens: an
               administrator can change the limit at any time. On custom limits
               the amount is exact rather than a maximum; the server's refusal
               says so, and an exact amount still sits within this range. */
            var withdrawLimit = parseFloat(data.subscription.withdrawalLimit);
            var withdrawBalance = parseFloat(data.subscription.wallet) || 0;
            var withdrawMost = isNaN(withdrawLimit) ? withdrawBalance : Math.min(withdrawBalance, withdrawLimit);
            //a limit set below the usual ₹500 minimum must still be usable
            var withdrawLeast = isNaN(withdrawLimit) ? 500 : Math.min(500, withdrawLimit);
            $$('#transferMoney input[name="amount"]')
              .attr('min', withdrawLeast)
              .attr('max', withdrawMost)
              .attr('data-error-message', withdrawMost >= withdrawLeast
                ? 'Enter an amount from '+INR.format(withdrawLeast)+' to '+INR.format(withdrawMost)
                : 'You need at least '+INR.format(withdrawLeast)+' in your wallet to withdraw');
            $$('.withdrawHint').html('Minimum '+INR.format(withdrawLeast)+' &middot; up to '+INR.format(withdrawMost));
            //"Withdraw again" from transaction history
            var repeat = takeRepeat('withdraw');
            if (repeat && repeat.amount) {
              $$('#transferMoney input[name="amount"]').val(String(+repeat.amount));
              app.toast.show({ text: 'Amount filled in from your earlier withdrawal. Check it, then withdraw.', closeTimeout: 3500 });
            }
            //check if bankAccounts is array or not
            if(Array.isArray(data.bankAccounts) && data.bankAccounts.length > 0) {
              $$('#transferMoney').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').removeClass('hidden');
              var allBankAccounts = data.bankAccounts;
              //create bank account select list in selectBeneficiary
              $$('.selectBeneficiary').empty();
              allBankAccounts.forEach(function(account, idx) {
                $$('#selectBeneficiary').append(
                  '<option value="'+account.bankAC+'"'
                  + ' data-beneficiary="'+account.beneficiaryName+'"'
                  + ' data-bankname="'+account.bankName+'"'
                  + ' data-ifsc="'+account.bankIFSC+'"'
                  + ' data-receiverphone="'+account.receiverPhone+'"'
                  + ' data-receiveremail="'+account.receiverMail+'"'
                  + (idx === 0 ? ' selected' : '')
                  + '>'
                  + account.beneficiaryName+' - '+account.bankAC+' ('+account.bankName+')'
                  + '</option>'
                );
              });
              //init select2
              $('#selectBeneficiary').select2({dropdownCssClass: 'ypw-select2-dropdown'});
              $$('.block-beneficiaryDetails').removeClass('hidden');
              //first show selected beneficiary details
              var selectedBeneficiary = $('#selectBeneficiary option:selected');
              renderBeneficiaryCard(selectedBeneficiary);
              //beneficiary content add value to each field
              $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
              $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
              $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
              $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
              $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              //on change of select box of beneficiary
              $('#selectBeneficiary').on('change', function() {
                var selectedBeneficiary = $('#selectBeneficiary option:selected');
                renderBeneficiaryCard(selectedBeneficiary);
                //beneficiary content add value to each field
                $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
                $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
                $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
                $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
                $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              });
            } else {
              $$('#transferMoney').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').addClass('hidden');
            }
            //create the add-beneficiary popup
            // Create Add Beneficiary Sheet
            var addBeneficiaryPopup = app.popup.create({
              content: `
              <div class="popup ypw-addpayee-popup add-beneficiary-popup">
                <div class="view">
                  <div class="page">
                    <div class="navbar ypw-appbar no-shadow">
                      <div class="navbar-bg"></div>
                      <div class="navbar-inner ypw-appbar__inner">
                        <div class="left">
                          <a href="#" class="link icon-only popup-close no-ripple ypw-appbar__btn" aria-label="Close">
                            <svg class="ypw-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14.5 5.5-6.5 6.5 6.5 6.5"/></svg>
                          </a>
                        </div>
                        <div class="title">Add bank account</div>
                      </div>
                    </div>
                    <div class="page-content ypw-addpayee-popup__content">
                      <form id="addBeneficiaryForm" class="ypw-form">
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnbeneficiary">Beneficiary name</label>
                          <div class="ypw-control">
                            <input type="text" name="bnbeneficiary" id="bnbeneficiary" required validate placeholder="Name as per bank records">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnaccount">Account number</label>
                          <div class="ypw-control">
                            <input type="password" name="bnaccount" id="bnaccount" inputmode="numeric" required validate placeholder="Enter account number">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bncaccount">Confirm account number</label>
                          <div class="ypw-control">
                            <input type="tel" name="bncaccount" id="bncaccount" inputmode="numeric" required validate placeholder="Re-enter account number">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnifsc">IFSC Code / Swift Code</label>
                          <div class="ypw-control">
                            <input type="text" name="bnifsc" id="bnifsc" minlength="8" maxlength="11" required validate placeholder="e.g. HDFC0001234">
                          </div>
                          <p class="ypw-error"></p>
                          <p class="ypw-hint">We'll look up the bank name for you.</p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnbankname">Bank name</label>
                          <div class="ypw-control">
                            <input type="text" name="bnbankname" id="bnbankname" required validate placeholder="Bank name">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnreceiverPhone">Phone <span class="ypw-label__opt">optional</span></label>
                          <div class="ypw-control">
                            <input type="tel" maxlength="10" minlength="10" name="bnreceiverPhone" id="bnreceiverPhone" inputmode="numeric" placeholder="10-digit number">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnreceiverEmail">Email <span class="ypw-label__opt">optional</span></label>
                          <div class="ypw-control">
                            <input type="email" name="bnreceiverEmail" id="bnreceiverEmail" validate placeholder="name@example.com">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-actions">
                          <button type="submit" class="button button-large button-fill bg-color-red addBeneficiaryBtn">Add beneficiary</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              `,
              // Events
              on: {
                open: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                },
                opened: function() {
                  if(localStorage.getItem('country') == 'IN') {
                    //get ifsc
                    $(document).off('keyup', '#bnifsc').on('keyup', '#bnifsc', function() {
                      if($$('#bnifsc').val().length == 11) {
                        app.preloader.show();
                        $.getJSON('https://ifsc.razorpay.com/'+$$('#bnifsc').val(), function(data) {app.preloader.hide();})
                        .done(function(data) {
                          app.preloader.hide();
                          $$('#bnbankname').val(data.BANK);
                          $$('.item-input-bank').addClass('item-input-focused');
                          $$('.item-input-bank').addClass('item-input-with-value');
                        })
                        .fail(function() {
                          app.preloader.hide();
                          app.toast.show({
                            text: 'Invalid IFSC code!',
                            closeTimeout: 3000,
                          });
                        })
                      }
                    });
                  }
                  // Handle Add Beneficiary Form Submission
                  /* Bound once, on the form itself. `opened` fires on every
                     open, and the delegated $(document).on('submit', ...) this
                     replaces stacked another handler each time -- after three
                     opens one tap sent three requests. */
                  /* `this` is the popup instance whose event fired (F7 emits
                     with context = the instance). The outer addBeneficiaryPopup
                     variable is not safe here: if the route initialises twice it
                     points at the newer popup, and the older popup's opened would
                     bind the listener to a detached form -- submitting then did
                     nothing at all. */
                  var thisPopup = this;
                  var beneficiaryFormEl = thisPopup.el.querySelector('#addBeneficiaryForm');
                  if (!beneficiaryFormEl.dataset.submitBound) {
                  beneficiaryFormEl.dataset.submitBound = '1';

                  /* A custom error must not outlive the edit that fixes it. */
                  beneficiaryFormEl.addEventListener('input', function(e) {
                    if (e.target.setCustomValidity) e.target.setCustomValidity('');
                  });

                  beneficiaryFormEl.addEventListener('submit', function(e) {
                    e.preventDefault();

                    /* The cross-field rule and the server's own limits cannot be
                       expressed as HTML constraints, so they are pushed into the
                       same constraint API the validator reads. Everything wrong
                       is then reported together, inline on the field it belongs
                       to, rather than one toast per round of guessing. */
                    var accountEl = beneficiaryFormEl.querySelector('#bnaccount');
                    var confirmEl = beneficiaryFormEl.querySelector('#bncaccount');
                    var ifscEl = beneficiaryFormEl.querySelector('#bnifsc');

                    accountEl.setCustomValidity(accountNumberError(accountEl.value) || '');
                    ifscEl.setCustomValidity(ifscError(ifscEl.value) || '');
                    confirmEl.setCustomValidity(
                      accountEl.value !== confirmEl.value ? 'Account numbers do not match' : ''
                    );

                    /* Marks every bad field, focuses the first, returns false. */
                    if (!validateScope(beneficiaryFormEl)) return;

                    var formData = app.form.convertToData('#addBeneficiaryForm');
                    formData.addBeneficiary = true;
                    formData.token = localStorage.getItem('authToken');
                    app.dialog.progress('Adding...');
                    /* app.methods.request, not app.request.post: it goes through
                       the wrapped $.ajax, so a 400 still carries the server's
                       `msg` instead of looking like a dropped connection. */
                    app.methods.request(
                    baseURL + '/app/php/lockers.php',
                    formData,
                    'json',
                    function() {},
                    function(data) {
                      app.dialog.close();
                      if (data && data.status === 'success') {
                      app.toast.show({ text: 'Beneficiary added successfully!', closeTimeout: 2000 });
                      thisPopup.close();
                      // Optionally, reload the page or update the beneficiary list here
                      //RELOAD CURRENT PAGE
                      var view = app.views.current;
                      view.router.navigate('/withdraw/', {
                        reloadCurrent: true,
                        ignoreCache: true,
                      })
                      } else {
                      app.toast.show({ text: (data && data.msg) || 'Failed to add beneficiary.', closeTimeout: 4000 });
                      }
                    },
                    function() {
                      app.dialog.close();
                      app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 });
                    }
                    );
                  });
                  }
                },
                close: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                }
              }
            });

            // Open Add Beneficiary Sheet on button click
            $$('.add-beneficiary-btn').on('click', function() {
              addBeneficiaryPopup.open();
            });
            //check if withdrawal limit is numeric or not
            if(!isNaN(data.subscription.withdrawalLimit)) {
              /* Worded so it holds for both meanings of the amount: a maximum
                 on the default limits, exact on custom ones. The counts are
                 shown only when subscribeInfo sends them. */
              var withdrawDaily = parseInt(data.subscription.dailyCount, 10);
              var withdrawMonthly = parseInt(data.subscription.monthlyCount, 10);
              var withdrawCounts = [];
              if (withdrawDaily > 0) withdrawCounts.push('<strong>'+withdrawDaily+'</strong> a day');
              if (withdrawMonthly > 0) withdrawCounts.push('<strong>'+withdrawMonthly+'</strong> a month');
              //one <span>: .ypw-notice is a flex row, and bare text beside
              //<strong>s would lay out as separate columns
              $$('.withdrawalLimit').html('<span>Withdrawals are <strong>'+INR.format(data.subscription.withdrawalLimit)+'</strong> each'
                + (withdrawCounts.length ? ', '+withdrawCounts.join(' and ') : '')
                + ', with a charge of <strong>'+data.subscription.withdrawalFee+'%</strong> per withdrawal.</span>');
            }
            else {
              $$('.withdrawalLimit').html('<span>You can withdraw from your wallet <strong>unlimited</strong> requests daily with a charge of <strong>'+data.subscription.withdrawalFee+'%</strong> per withdrawal.</span>');
            }
            $$('.cashbackTXT').html('You will get <strong>'+data.subscription.cashback+'%</strong> cashback on withdrawal charge after 45 days.');
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        //get ifsc
        $$('#ifsc').on('keyup', function() {
          if($$('#ifsc').val().length == 11) {
            app.preloader.show();
            $.getJSON('https://ifsc.razorpay.com/'+$$('#ifsc').val(), function(data) {app.preloader.hide();})
            .done(function(data) {
              app.preloader.hide();
              $$('#bankname').val(data.BANK);
              $$('.item-input-bank').addClass('item-input-focused');
              $$('.item-input-bank').addClass('item-input-with-value');
            })
            .fail(function() {
              app.preloader.hide();
              app.toast.show({
                text: 'Invalid IFSC code!',
                closeTimeout: 3000,
              });
            })
          }
        });
        //send a request to server to get last withdrawal details
        // app.methods.request(
        //   baseURL+'/app/php/lockers.php',
        //   {getLastWithdrawal: true, token: localStorage.getItem('authToken')},
        //   'json',
        //   function() { app.dialog.progress('Loading...'); },
        //   function(data) {
        //     app.dialog.close();
        //     if(data.status == 'success') {
        //       if(data.lastWithdrawal) {
        //         if(data.lastWithdrawal.feesStatus == '0') {
        //           //navigate to fees payment page
        //           setTimeout(() => {
        //             var view = app.views.current;
        //             view.router.navigate('/fees/transaction/'+data.lastWithdrawal.txnID);
        //             console.log('Fees not paid, redirecting to fees payment page.');
        //           }, 1000);
        //         }
        //       } else {
        //         console.log('No withdrawal details found.');
        //       }
        //     } else {
        //       app.toast.show({
        //         text: data.msg,
        //         closeTimeout: 3000,
        //       });
        //     }
        //   },
        //   function() {
        //     app.dialog.close();
        //     app.toast.show({
        //       text: 'No internet connection!',
        //       closeTimeout: 3000,
        //     });
        //   }
        // );
        //onkeyup of amount
        // $$('#amount').on('keyup', function() {
        //   var amount = $$('#amount').val();
        //   var wallet = $$('#wallet').val();
        //   // Numeric validation
        //   if (isNaN(amount) || amount === '' || parseFloat(amount) <= 0) {
        //     $$('.withdrawMoney').addClass('disabled');
        //     return;
        //   }
        //   if (parseFloat(amount) > parseFloat(wallet)) {
        //     $$('.withdrawMoney').addClass('disabled');
        //   } else {
        //     $$('.withdrawMoney').removeClass('disabled');
        //   }
        // });
        //submit withdrawal request
        $$('.withdrawMoney').on('click', function() {
          if (!$$('#transferMoney')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            withdrawMoney();
          }
        });
        function withdrawMoney() {
          /* Same rules the server now enforces on the account number and the
             IFSC / SWIFT code, checked before we spend a round trip on them. */
          var beneficiaryProblem =
            accountNumberError($$('#transferMoney #account').val()) ||
            ifscError($$('#transferMoney #ifsc').val());
          if(beneficiaryProblem) {
            app.toast.show({ text: beneficiaryProblem, closeTimeout: 4000 });
            return;
          }
          var formdata = $('#transferMoney').serialize();
          var data = formdata+'&withdraw=true&token='+localStorage.getItem('authToken');
          app.methods.request(
            baseURL+'/app/php/lockers.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet-loan--applied');
                $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Withdrawal Requested!');
                $$('.sheet-loan--applied__text').html('Money will be transferred to your bank account once we verify your withdrawal, please wait while we\'re verifying your withdrawal.');
                var view = app.views.current;
                view.router.back('/',{force:true});
              }
              //needs KYC, or over the monthly withdrawal limit
              else if(!walletRefusal(app, data)) {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        
        }
      }
    }
  },
  {
    path: '/money-transfer/',
    //a minimum-KYC wallet cannot send money: explain and offer KYC instead
    beforeEnter: walletGate('transfer'),
    component: MoneyTransferPage,
    name: 'money-transfer',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //get subscription details
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            $$('.wallet--amount').html(INR2.format(data.subscription.wallet));
            $$('input[name="amount"]').attr('max', data.subscription.wallet);
            $$('input[name="wallet"]').val(data.subscription.wallet);
            /* "Send again" from transaction history: the amount, and the
               recipient too once history rows carry their phone. Typing the
               tenth digit is what looks the recipient up, so that is replayed. */
            var repeat = takeRepeat('transfer');
            if (repeat) {
              $$(page.el).find('#amount').val(repeat.amount ? String(+repeat.amount) : '');
              var phoneEl = $$(page.el).find('#beneficiaryNumber')[0];
              if (repeat.phone && phoneEl) {
                phoneEl.value = repeat.phone;
                phoneEl.dispatchEvent(new Event('keyup', { bubbles: true }));
              }
              app.toast.show({
                text: repeat.phone ? 'Filled in from your earlier transfer. Check, then send.' : 'Amount filled in from your earlier transfer. Enter the recipient\'s number.',
                closeTimeout: 3500,
              });
            }
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        //on key up beneficiary phone
        // Prevent multiple event bindings on beneficiaryNumber input
        $$('#beneficiaryNumber').off('keyup');
        $$('#beneficiaryNumber').on('keyup', function() {
          var beneficiary = $$('#beneficiaryNumber').val();
          if(beneficiary.length == 10) {
            //validate it's a valid phone number
            if(!/^\d{10}$/.test(beneficiary)) {
              app.toast.show({
                text: 'Please enter a valid 10 digit phone number!',
                closeTimeout: 3000,
              });
              return;
            }
            //send request to server to validate beneficiary
            app.dialog.progress('Validating Beneficiary...');
            $.getJSON(baseURL+"app/php/lockers.php?validateBeneficiaryNumber=true&beneficiary="+beneficiary+"&token="+localStorage.getItem('authToken'), function() {
              app.dialog.close();
            })
            .done(function(data) {
              app.dialog.close();
              if(data.status == 'success') {
                $('.beneficiaryDetails').empty();
                $('.beneficiaryDetails').append('<div class="ypw-payee">\
                  <span class="ypw-payee__icon">\
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>\
                  </span>\
                  <span class="ypw-payee__body">\
                    <span class="ypw-payee__label">Sending to</span>\
                    <span class="ypw-payee__name"></span>\
                  </span>\
                </div>');
                //set as text, not interpolated into the markup above
                $('.beneficiaryDetails .ypw-payee__name').text(data.userDetails.name);
                $$('#uid').val(data.userDetails.id);
                $$('.transferMoney').removeClass('disabled');
              } else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            })
            .fail(function() {
              app.dialog.close();
              app.toast.show({
                text: 'Something went wrong, please try again!',
                closeTimeout: 3000,
              });
            });
          }
        });
        //submit transfer request
        $$('.transferMoney').on('click', function() {
          if (!$$('#transferMoneyWallet')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            withdrawMoney();
          }
        });
        function withdrawMoney() {
          var formdata = $('#transferMoneyWallet').serialize();
          var data = formdata+'&transferMoneyWallet=true&token='+localStorage.getItem('authToken');
          app.methods.request(
            baseURL+'/app/php/lockers.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet-loan--applied');
                $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Money Transfer Successful!');
                $$('.sheet-loan--applied__text').html('Money has been transferred to wallet of '+data.receiverName+', your current wallet balance is '+INR2.format(data.walletBalance)+'.');
                var view = app.views.current;
                view.router.back('/',{force:true});
              }
              //needs KYC, over the monthly limit, or the recipient cannot take it
              else if(!walletRefusal(app, data)) {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        
        }
      }
    }
  },
  {
    /* Wallet ledger, locker payments or investment withdrawals, with filters
       on the wallet list; every row opens /txn/:key/. See history.js. */
    path: '/transaction/:type',
    beforeEnter: requireSignIn,
    component: TransactionPage,
    name: TransactionPage,
    on: {
      pageInit: function(e, page) {
        initHistoryPage(this.app, page, baseURL, INR2);
      }
    }
  },
  {
    /* One transaction in full, with Repeat and (for a withdrawal whose fee is
       unpaid) Pay fee */
    path: '/txn/:key/',
    beforeEnter: requireSignIn,
    component: TransactionDetailsPage,
    name: 'transaction-details',
    on: {
      pageInit: function(e, page) {
        initTxnDetailsPage(this.app, page, baseURL, INR2);
      }
    }
  },
  {
    path: '/invest/',
    component: InvestPage,
    name: 'invest',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        $$('.btn-investNow').on('click', function() {
          $$('.investNowBTN').addClass('disabled');
          app.popup.open('.sheet--invest');
          //get if invested or not
          app.methods.getUserDataInvest(function(data) {
          if(data.status == 'success') {
            // if(data.sponsorReferralCode != '') {
            //   $$('input[name="referralCode"]').val(data.sponsorReferralCode);
            //   $$('input[name="referralCode"]').attr('readonly', 'readonly');
            //   $$('.item-input-reffer').addClass('item-input-focused');
            //   $$('.item-input-reffer').addClass('item-input-with-value');
            // }
          } else {
            // console.log(data.sponsorReferralCode);
            // if(data.sponsorReferralCode != '') {
            //   $$('input[name="referralCode"]').val(data.sponsorReferralCode);
            //   $$('input[name="referralCode"]').attr('readonly', 'readonly');
            //   $$('.item-input-reffer').addClass('item-input-focused');
            //   $$('.item-input-reffer').addClass('item-input-with-value');
            // }
          }
          });
        });
        //get selected investment return on keyup of amount
        $$('#amount-invest').on('keyup', function() {
          var amount = parseFloat($$('#amount-invest').val());
          var multiplier = parseFloat($('#invest-days option:selected').attr('data-multiplier'));
          if (!isNaN(amount) && !isNaN(multiplier)) {
            var estimatedReturn = amount * multiplier;
            var returnIN = parseFloat($('#invest-days option:selected').attr('data-return'));
            if (amount >= 1000) {
                $$('.totalReturn').html('Your investment of <b>' + INR2.format(amount) + '</b> will be equivalent to <b>999 (24K) pure GOLD</b>,\
                and credit limit of <b>' + INR2.format(estimatedReturn) + '</b>.');
                $$('.investNowBTN').removeClass('disabled');
                $$('.investNowBTN').attr('data-days', $('#invest-days').val());
                $$('.investNowBTN').attr('data-amount', amount);
            } else {
              $$('.totalReturn').html('');
              $$('.investNowBTN').addClass('disabled');
            }
          } else {
            $$('.totalReturn').html('');
            $$('.investNowBTN').addClass('disabled');
          }
        });
        //on invest-days change show the amount would become this in that days
        $('#invest-days').on('change', function() {
          var amount = parseFloat($$('#amount-invest').val());
          var days = $$('#invest-days').val();
          var multiplier = parseFloat($('#invest-days option:selected').attr('data-multiplier'));
          if (!isNaN(amount) && !isNaN(days) && !isNaN(multiplier)) {
            var estimatedReturn = amount * multiplier;
            var returnIN = parseFloat($('#invest-days option:selected').attr('data-return'));
            if (amount >= 1000) {
              $$('.totalReturn').html('Your investment of <b>' + INR2.format(amount) + '</b> will be equivalent to <b>999 (24K) pure GOLD</b>,\
                and credit limit of <b>' + INR2.format(estimatedReturn) + '</b>.');
              $$('.investNowBTN').removeClass('disabled');
              $$('.investNowBTN').attr('data-days', $('#invest-days').val());
              $$('.investNowBTN').attr('data-amount', amount);
            } else {
              $$('.totalReturn').html('');
              $$('.investNowBTN').addClass('disabled');
            }
          } else {
            $$('.totalReturn').html('');
            $$('.investNowBTN').addClass('disabled');
          }
        });
        $('#invest-days').select2({minimumResultsForSearch: -1});
        $$('.popup-close-tc').on('click', function() {
          app.popup.close('.sheet--invest-tc');
        });
        $$('.investNowBTN').on('click', function() {
          //validate referralCode
          // if (!$$('input[name="referralCode"]')[0].checkValidity()) {
          //   console.log('Check Validity!');
          //   return;
          // } else {
          //   verifyReferralCode();
          // }
          app.popup.open('.sheet--invest-payment');
          $$('.investAmount').html(INR2.format($$(this).attr('data-amount')));
          //calculate gold QTY in gm from API value
          $.getJSON(baseURL+"app/php/invest.php?goldPrice=true&token="+localStorage.getItem('authToken'), function(data) {
            if(data.status == 'success') {
              var goldPrice = parseFloat(data.goldPrice); //this price is for 1gm
              // calculate quantity in gm for 999 pure gold
              var finalPrice = $$('.investNowBTN').attr('data-amount') - ($$('.investNowBTN').attr('data-amount') * 18 / 100); //subtract GST from amount
              var goldQty = finalPrice / goldPrice;
              $$('.currentGoldPrice').html(goldPrice.toFixed(2));
              $$('.goldQTY').html(goldQty.toFixed(3) + ' gm of 999 (24K) pure GOLD');
            } else {
              $$('.goldQTY').html('N/A');
              $$('.currentGoldPrice').html('N/A');
            }
          });
          $$('.payableAmount').html(INR2.format($$(this).attr('data-amount'))+' (Inc. GST)');
        });
        function verifyReferralCode() {
          var referralCode = $$('input[name="referralCode"]').val().trim();
          app.methods.request(
            baseURL+'/app/php/invest.php',
            {verifyReferralCode: true, referralCode: referralCode, token: localStorage.getItem('authToken')},
            'json',
            function() { app.dialog.progress('Verifying Referral Code...'); },
            function(data) {
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet--invest-payment');
                $$('.investAmount').html(INR2.format($$('.investNowBTN').attr('data-amount')));
                $$('.investDays').html($$('.investNowBTN').attr('data-days')+ ' Days');
                var goldPrice = parseFloat(data.goldPrice); //this price is for 1gm
                // calculate quantity in gm for 999 pure gold
                var finalPrice = $$('.investNowBTN').attr('data-amount') - ($$('.investNowBTN').attr('data-amount') * 18 / 100); //subtract GST from amount
                var goldQty = finalPrice / goldPrice;
                $$('.goldQTY').html(goldQty.toFixed(3) + ' gm of 999 (24K) pure GOLD');
                $$('.currentGoldPrice').html(goldPrice.toFixed(2));
                $$('.payableAmount').html(INR2.format($$('.investNowBTN').attr('data-amount'))+' (Inc. GST)');
                $$('.sponsorName').html(data.sponsorName);
              } else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        $$('.popup-close-payment').on('click', function() {
          app.popup.close('.sheet--invest-payment');
        });
        
        app.methods.getBank(function(data) {
          app.dialog.close();
          //bank rows, UPI block and copy buttons, or the
          //no-methods state when neither is configured
          renderBankDetails('.getBankdet', data, baseURL);
        });
        //upload payment for investment
        $$('.submitInvest').on('click', function() {
          var paymentIMG = $$('#paymentReceipt').prop('files')[0];
          var utr = $$('#utr-invest').val();
          var formData = new FormData();
          formData.append('submitInvest', true);
          formData.append('token', localStorage.getItem('authToken'));
          formData.append('paymentIMG', paymentIMG);
          formData.append('utr', utr);
          formData.append('amount', $$('#amount-invest').val());
          formData.append('investDays', $$('#invest-days').val());
          //formData.append('referralCode', $$('#referralCode').val());
          if(!$$('#amount-invest')[0].checkValidity()) {
            app.toast.show({
              text: 'Please enter your investment amount!',
              closeTimeout: 3000,
            });
          }
          else if(utrError(utr)) {
            app.toast.show({
              text: utrError(utr),
              closeTimeout: 4000,
            });
          }
          else if(!$$('#paymentReceipt')[0].checkValidity()) {
            app.toast.show({
              text: 'Please attach the payment screenshot.',
              closeTimeout: 3000,
            });
          }
          else {
            var uploadError = imageError($$('#paymentReceipt').prop('files')[0]);
            if (uploadError) {
              app.toast.show({
                text: uploadError,
                closeTimeout: 4000,
              });
            } else {
              app.methods.post(
                baseURL+'app/php/invest.php',
                formData,
                'json',
                function() {
                  app.dialog.progress('Loading...');
                },
                function(data) {
                  app.dialog.close();
                  if(data.status == 'success') {
                    //close all popups
                    app.popup.close('.sheet--invest-payment');
                    app.popup.close('.sheet--invest');
                    app.popup.open('.sheet-loan--applied');
                    $$('.sheet-loan--applied__title').html(INR2.format($$('#amount-invest').val())+' Investment Requested!');
                    $$('.sheet-loan--applied__text').html('Your investment request has been successfully submitted, we will verify your payment and \
                      activate your investment as soon as possible. Please wait while we\'re verifying your payment.');
                    var view = app.views.current;
                    view.router.back('/invest-dashboard/',{force:true});
                  }
                  else {
                    app.toast.show({
                      text: data.msg,
                      closeTimeout: 3000,
                    });
                  }
                },
                function() {
                  app.dialog.close();
                  app.toast.show({
                  text: 'Something went wrong, please try again!',
                  closeTimeout: 3000,
                });
                }
              );
            }
          }
        });
      }
    }
  },
  {
    path: '/invest-dashboard/',
    component: InvestDashboardPage,
    name: 'invest-dashboard',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').on('click', function() {
          var shareLink = 'https://app.youpaywallet.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join YouPayWallet',
              text: 'Use my referral code to join YouPayWallet!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        //get investment details
        app.methods.getUserDataInvest(function(data) {
          if(data.status == 'success') {
            //each function
            $$('.all-invest--list ul').empty();
            $.each(data.data, function(i, item) {
              if(item.status == '0') {
                var status = 'Processing';
                var statusColor = 'text-color-orange';
                var img = 'https://cdn-icons-png.flaticon.com/512/15092/15092613.png';
                var date = 'Invested on '+item.date;
                var creditTXT = 'Your investment of <b class="text-color-green">'+INR.format(item.amount)+'</b> is being processed, please wait for it to be activated soon.';
                // var dateExpire = '';
                // var goldDeliveryTxt = 'You will receive gold worth of <b class="text-color-green">'+INR.format(item.estimatedReturn)+'</b> \
                // after <b class="text-color-green">'+item.halfway+'</b> days.';
              } else if(item.status == '1') {
                var status = 'Active';
                var statusColor = 'text-color-green';
                var img = 'assets/icons/profit.gif';
                var date = 'Activated on '+item.dateStart;
                var dateStart = item.dateStart;
                // safe parse start date into a valid Date, supporting various formats
                function safeParseDate(d) {
                  if (!d) return new Date();
                  if (d instanceof Date) return d;
                  var dt = new Date(d);
                  if (!isNaN(dt.getTime())) return dt;
                  // try replacing - with / and parse
                  var s = String(d).replace(/-/g, '/');
                  var parts = s.split('/');
                  // handle DD/MM/YYYY -> convert to YYYY-MM-DD for reliable parse
                  if (parts.length === 3 && parts[0].length === 2) {
                    var rearr = parts[2] + '-' + parts[1] + '-' + parts[0];
                    dt = new Date(rearr);
                    if (!isNaN(dt.getTime())) return dt;
                  }
                  dt = new Date(s);
                  return isNaN(dt.getTime()) ? new Date() : dt;
                }
                var parsedStart = safeParseDate(dateStart);
                // calculate date after 15 days from start date
                var dateAfter15Days = new Date(parsedStart);
                dateAfter15Days.setDate(dateAfter15Days.getDate() + 15);
                var dateAfter15DaysStr = dateAfter15Days.getDate() + '/' + (dateAfter15Days.getMonth() + 1) + '/' + dateAfter15Days.getFullYear();
                // calculate how many days left from today to dateAfter15Days
                var today = new Date();
                var timeDiff = dateAfter15Days.getTime() - today.getTime();
                var daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
                if (daysLeft < 0) daysLeft = 0;
                var creditTXT = 'Credit limit of <b class="text-color-green">'+INR.format(item.estimatedReturn)+'</b> will be available after <b class="text-color-green">'+daysLeft+'</b> days.';
                // var dateExpire = 'Closing on '+item.dateExpire;
                // var goldDeliveryTxt = 'You will receive gold worth of <b class="text-color-green">'+INR.format(item.estimatedReturn)+'</b> \
                // after <b class="text-color-green">'+item.halfway+'</b> days.';
              } else {
                var status = 'Closed';
                var statusColor = 'text-color-red-deep';
                var img = 'assets/icons/error.png';
                var date = 'Closed on '+item.dateExpire;
                var creditTXT = '';
                // var dateExpire = '';
                // var goldDeliveryTxt = '';
              }
              // if(item.withdrawn == 0) {
              //   var warningTXT = '';
              //   goldDeliveryTxt = 'You will receive gold worth of <b class="text-color-green">'+INR.format(item.estimatedReturn)+'</b> \
              //   after <b class="text-color-green">'+item.halfway+'</b> days.';
              // } else {
              //   var warningTXT = 'As you have already withdrawn your investment, you can not get gold benefits from this investment anymore.';
              //   goldDeliveryTxt = '';
              // }
              $$('.all-invest--list ul').append('<li>\
                <a href="#" class="item-link item-content item-investment" data-id="'+item.investID+'">\
                <div class="item-media"><img src="'+img+'" width="40"/></div>\
                <div class="item-inner">\
                <div class="item-title text-color-blue fw-600">Invested: '+INR.format(item.amount)+'</div>\
                <div class="item-title text-color-blue fw-600 text-whitespace">Credit Limit: '+INR.format(item.estimatedReturn)+' \
                </div>\
                <div class="item-text item-credit-txt">Investment Ref ID #'+item.investID+'</div>\
                <div class="item-subtitle f-12 fw-600 '+statusColor+'">'+status+'</div>\
                <div class="item-text item-credit-txt">'+creditTXT+'</div>\
                </div></a>\
              </li>');
              //check in this each loop if first item is closed or not
              if(i == 0) {
                if(item.status == '2' || item.status == '1') {
                  $$('.item__link--invest-new').removeClass('disabled, no-invest__toast');
                  $$('.item__link--invest-new').attr('href', '/invest/');
                  $$('.item__link--earning').attr('href', '/earning/');
                } else {
                  $$('.item__link--invest-new').addClass('disabled', 'no-invest__toast');
                }
              }
            });
            $$('.gold-price').html(INR2.format(data.goldRate));
            //calculate gold quantity, gold price is in for 1 gram
            var walletwithoutGST = data.wallet - (data.wallet * 18 / 100); //subtract GST from wallet amount
            var goldQuantity = (walletwithoutGST / data.goldRate);
            $$('.gold-quantity').html(parseFloat(goldQuantity).toFixed(3) + ' Grams');
            //set wallet amount
            $$('.invest__wallet--amount').html(
              INR2.format(data.wallet) + 
              ' <span style="font-size: 14px;">(' + parseFloat(goldQuantity).toFixed(3) + ' Grams)</span>'
            );
            $$('.item_link--returns').attr('href', '/returns/');
            $$('.item__link--withdraw').attr('href', '/invest-withdraw/');
            $$('.item__link--history').attr('href', '/transaction/investment');
          } else {
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        $$(document).on('click', '.no-invest__toast', function() {
          app.toast.show({
            text: 'You can\'t invest now, please wait for until your current investment is closed!',
            closeTimeout: 3000,
          });
        });
        $(document).off('click', '.item-investment');
        $(document).on('click', '.item-investment', function(e) {
          e.preventDefault();
          var investID = $(this).attr('data-id');
          if (!investID) {
            app.toast.show({
              text: 'Investment ID not found!',
              closeTimeout: 3000,
            });
            return;
          }
          app.methods.getUserDataInvest(function(data) {
            if (data.status == 'success') {
              var itemData = data.data.find(item => item.investID === investID);
              if(itemData.status == '0') {
                var status = 'Processing';
                var statusColor = 'text-color-orange';
              } else if(itemData.status == '1') {
                var status = 'Active';
                var statusColor = 'text-color-green';
              } else {
                var status = 'Closed';
                var statusColor = 'text-color-red-deep';
              }
              if (itemData.date && typeof itemData.date === 'string') {
                // Remove time part if present (e.g. "2024-06-10 12:34:56" => "2024-06-10")
                itemData.date = itemData.date.split(' ')[0];
              }
              itemData.amount = INR2.format(itemData.amount);
              itemData.estimatedReturn = INR2.format(itemData.estimatedReturn);
              itemData.dailyReturn = INR2.format(itemData.dailyReturn);
              if(itemData.withdrawn > 0) {
                var goldDelivery = 'Not-Eligible';
                var goldDeliveryClass = 'text-color-red-deep';
              } else {
                var goldDelivery = 'Eligible After '+itemData.halfwayDate;
                var goldDeliveryClass = 'text-color-green';
              }
              itemData.withdrawn = itemData.withdrawn > 0 ? INR2.format(itemData.withdrawn) : 'N/A';
              if (!itemData) {
                app.toast.show({
                  text: 'Investment details not found!',
                  closeTimeout: 3000,
                });
                return;
              }
                var detailsSheet = app.sheet.create({
                content: `
                  <div class="sheet-modal sheet-investment-details" style="height:auto;">
                  <div class="toolbar">
                    <div class="toolbar-inner">
                    <div class="title text-color-blue margin-left"><h3 class="text-color-blue text-align-left">Investment Details</h3></div>
                    <div class="right">
                      <a href="#" class="link sheet-close">
                      <img src="assets/icons/x-button.png" width="24" height="24" alt="Close" class="icon icon-close">
                      </a>
                    </div>
                    </div>
                  </div>
                  <div class="sheet-modal-inner">
                    <div class="sheet-modal-text">
                    <div class="list">
                      <ul>
                      <li><div class="item-content"><div class="item-inner"><div class="item-title">Investment Reference ID</div><div class="item-after">${itemData.investID}</div></div></div></li>
                      <li><div class="item-content"><div class="item-inner"><div class="item-title">Amount</div><div class="item-after">${itemData.amount}</div></div></div></li>
                      <li><div class="item-content"><div class="item-inner"><div class="item-title">Credit Limit</div><div class="item-after">${itemData.estimatedReturn}</div></div></div></li>
                      <li><div class="item-content"><div class="item-inner"><div class="item-title">Status</div><div class="item-after fw-600 ${statusColor}">${status}</div></div></div></li>
                      <li><div class="item-content"><div class="item-inner"><div class="item-title">Activation Date</div><div class="item-after">${itemData.date}</div></div></div></li>
                      </ul>
                    </div>
                    <div class="block text-align-center">
                      <button class="button button-fill button-large button-gradient bg-color-red sheet-close" style="width: 100%;">Okay</button>
                    </div>
                    </div>
                  </div>
                  </div>
                `,
                swipeToClose: true,
                backdrop: true
                });
              detailsSheet.open();
            } else {
              app.toast.show({
                text: 'Investment details not found!',
                closeTimeout: 3000,
              });
            }
          });
        });
      }
    }
  },
  {
    path: '/earning/',
    component: EarningPage,
    name: 'earning',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').on('click', function() {
          var shareLink = 'https://app.youpaywallet.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join YouPayWallet',
              text: 'Use my referral code to join YouPayWallet!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        //get eraning from server
        app.methods.request(
          baseURL+'/app/php/earning.php',
          {getEarnings: true, token: localStorage.getItem('authToken')},
          'json',
          function() { app.dialog.progress('Loading Earnings...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              $$('.network__wallet--amount').html(INR2.format(data.data.myCommissionAmount));
              $$('.total-members').html(data.data.teamMembers);
              $$('.total-direct-referrals').html(data.data.directMembers);
              $$('.team-commission').html(INR2.format(data.data.totalCommission));
              $$('.direct-commission').html(INR2.format(data.data.totalDirectCommission));
              // Set progress bar
              var current = parseFloat(data.data.totalCommission);
              var cap = parseFloat(data.data.commissionCap);
              $$('.commissionCappingtext').html(INR2.format(current) + ' / ' + INR2.format(cap));
              var percentage = Math.min((current / cap) * 100, 100); // Ensure percentage does not exceed 100%
              // Set progress dynamically
              app.progressbar.set('#earnings-progress', percentage);
              if(data.data.teamMembers > 0) {
                $$('.item__link--earning-team').attr('href', '/my-team/');
              }
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
          }
        );
      }
    }
  },
  {
    path: '/my-team/',
    component: MyTeamPage,
    name: 'my-team',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //get eraning from server
        app.methods.request(
          baseURL+'/app/php/earning.php',
          {getEarnings: true, token: localStorage.getItem('authToken')},
          'json',
          function() { app.dialog.progress('Loading Earnings...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              $$('.total-members').html(data.data.teamMembers);
              $$('.total-direct-referrals').html(data.data.directMembers);
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
          }
        );
        //my team data
        app.methods.request(
          baseURL+'/app/php/earning.php',
          {myTeam: true, token: localStorage.getItem('authToken')},
          'json',
          function() { app.dialog.progress('Loading Data...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if (Array.isArray(data.data.binaryTree) && data.data.binaryTree.length > 0) {
                $$('.all-teams--list ul').empty();
                data.data.binaryTree.forEach(function(member) {
                  var status = member.network.status == '1' ? 'Active' : 'Inactive';
                  var statusColor = member.network.status == '1' ? 'text-color-green' : 'text-color-red-deep';
                  $$('.all-teams--list ul').append(
                    '<li>' +
                      '<div class="item-content">' +
                        '<div class="item-media">' +
                          '<img src="https://ui-avatars.com/api/?background=fbd2e4&color=ed1e79&length=2&rounded=true&bold=true&name=' + encodeURIComponent(member.user.name) + '" width="40"/>' +
                        '</div>' +
                        '<div class="item-inner">' +
                          '<div class="item-title-row">' +
                            '<div class="item-title fw-600">' + member.user.name + '</div>' +
                            '<div class="item-after f-12 fw-600 ' + statusColor + '">' + status + '</div>' +
                          '</div>' +
                          '<div class="item-subtitle f-12">' + member.user.email + '</div>'+
                          '<div class="item-text text-color-blue f-14 fw-600">Total Investment:' + INR2.format(member.totalInvestment) + '</div>' +
                        '</div>' +
                      '</div>' +
                    '</li>'
                  );
                });
              } else {
                $$('.all-teams--list ul').empty();
                $$('.all-teams--list ul').append(
                  '<li>' +
                    '<div class="item-content">' +
                      '<div class="item-inner text-align-center">' +
                        '<img src="assets/icons/no-data.png" height="70" style="margin-top: 25px;"/>' +
                        '<h3 class="text-color-blue f-16">No direct members found!</h3>' +
                      '</div>' +
                    '</div>' +
                  '</li>'
                );
              }
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
          }
        );
        //check if popup-genealogy-tree opened or not
        // Recursively convert the structure to Tree.js format
        function convertToJsTree(node) {
          const item = {
            text: node.name+' ('+node.position+')'
          };

          if (node.children && node.children.length > 0) {
            item.children = node.children.map(convertToJsTree);
          }

          return item;
        }

        $$(document).on('popup:opened', '.popup-genealogy-tree', function () {
          // You can add any logic here that should run when the genealogy tree popup is opened
            //get genealogy tree data
            app.methods.request(
            baseURL + '/app/php/earning.php',
            { getGenealogyTree: true, token: localStorage.getItem('authToken') },
            'json',
            function() { app.dialog.progress('Loading Genealogy Tree...'); },
            function(data) {
              app.dialog.close();
              if (data.status === 'success' && data.data.genealogyTree) {
                const convertedChildren = data.data.genealogyTree.map(convertToJsTree);
                // Clear previous tree and style container
                $$('.genealogy-tree-container').empty();
                $$('.genealogy-tree-container').removeClass('text-align-center');
                $$('.genealogy-tree-container').addClass('text-align-left');
                // Initialize jsTree with custom icons/colors
                $('#tree-container').jstree({
                  core: {
                  themes: {
                    name: 'default',
                    responsive: false
                  },
                  data: convertedChildren
                  },
                  types: {
                  default: {
                    icon: 'fa fa-user text-color-red'
                  }
                  },
                  plugins: ['types']
                });
              }
            },
            function() {
              app.dialog.close();
              $$('.genealogy-tree-container').empty();
              $$('.genealogy-tree-container').append('<img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
              <p class="fs-16 fw-600 text-color-blue">Failed to load genealogy data. Please try again later.</p>\
              )');
            }
            );
        });
      }
    }
  },
  {
    path: '/returns/',
    component: ReturnPage,
    name: 'returns',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //check if logged in or not
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.dialog.close();
              //get payment history
              $.post(baseURL+"app/php/invest.php", {returnHistory:true,token:localStorage.getItem('authToken')}, function() {
                app.dialog.close();
              })
              .done(function(data) {
                app.dialog.close();
                if(data.status == 'success') {
                  $$('.txn-history .list ul').empty();
                  if(typeof data.returnHistory == 'undefined' || data.returnHistory.length == 0) {
                    $$('.txn-history').empty();
                    $$('.txn-history').append('<div class="text-align-center">\
                      <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                      <h3 class="text-color">No return history found!</h3>\
                    </div>');
                  } else {
                    $.each(data.returnHistory, function(i, item) {
                      if(item.status == '0') {
                        var status = 'Pending';
                        var statusColor = 'text-color-orange';
                        var img = 'assets/icons/pending.png';
                      } else if(item.status == '1') {
                        var status = 'Success';
                        var statusColor = 'text-color-green';
                        var img = 'assets/icons/checked.png';
                      } else {
                        var status = 'Failed';
                        var statusColor = 'text-color-red-deep';
                        var img = 'assets/icons/error.png';
                      }
                      if(item.type == '1') {
                        var title = 'Daily Return Received';
                      } else {
                        var title = 'Refund Received';
                      }
                      $$('.txn-history .list ul').append('<li>\
                      <div class="item-content">\
                        <div class="item-media">\
                          <img src="'+img+'" height="40">\
                        </div>\
                        <div class="item-inner">\
                          <div class="item-title-row">\
                            <div class="item-title fw-600">'+title+'</div>\
                            <div class="item-after f-16 fw-600 text-color-blue">'+INR2.format(item.amount)+'</div>\
                          </div>\
                          <div class="item-text f-12">'+item.investID+'</div>\
                          <div class="item-text f-12">ROI: '+item.roi+'%</div>\
                          <div class="item-subtitle f-12 fw-600 '+statusColor+'">'+status+'</div>\
                          <div class="item-text f-12">'+item.date+'</div>\
                        </div>\
                      </div>\
                    </li>');
                    });
                  }
                } else {
                  $$('.txn-history').empty();
                  $$('.txn-history').append('<div class="text-align-center">\
                    <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                    <h3 class="text-color-blue f-16">No return history found!</h3>\
                  </div>');
                }
              })
              .fail(function() {
                app.dialog.close();
                app.toast.show({
                  text: 'Something went wrong, please try again!',
                  closeTimeout: 3000,
                });
              });
            } else {
              app.dialog.close();
              app.views.main.router.navigate({name: 'Home'});
            }
        });
      }
    }
  },
  {
    path: '/invest-withdraw/',
    component: InvestWithdrawPage,
    name: 'invest-withdraw',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //get subscription details
        app.methods.getUserDataInvest(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            data.withdrawalBal = parseFloat(data.withdrawalBal);
            $$('.wallet--amount').html(INR2.format(data.withdrawalBal));
            $$('input[name="amount"]').attr('max', data.withdrawalBal);
            $$('input[name="wallet"]').val(data.withdrawalBal);
            //each loop
            $$('#investmentSelect').empty();
            $.each(data.data, function(i, item) {
              //filter item where item.status is 1
              if(item.status != '1') {
                return;
              }
              $$('#investmentSelect').append('<option value="'+item.investID+'" data-wallet="'+item.wallet+'">'+item.investID+' - '+INR.format(item.wallet)+' - '+item.roi+'x Returns - '+item.days+' Days</option>');
              //select2
              $('#investmentSelect').select2({minimumResultsForSearch: -1});
              //get which investment is selected
              var investID = $$('#investmentSelect').val();
              //match investment id with selected investment
              if(item.investID == investID) {
                $$('.wallet--amount').html(INR2.format(item.withdrawalLimit));
                $$('input[name="amount"]').attr('max', item.maxWithdrawal);
                $$('input[name="wallet"]').val(item.withdrawalLimit);
                //if item.withdrawn is null show a dialog box warning
                if(item.withdrawn == 0) {
                  $$('.card__warning').removeClass('hidden');
                  $$('.holding-date').html(item.halfwayDate);
                  $$('.gold-amount').html(INR2.format(item.wallet));
                } else {
                  $$('.card__warning').removeClass('hidden');
                  $$('.card__warning-txt').html('As you have already withdrawn your investment, you can not get gold benefits from this investment anymore.');
                }
                //calculate item.withdrawalLimit + 5%, if it's 1000 then it should be 1050
                var withdrawalwithTax = +item.withdrawalLimit + +(item.withdrawalLimit * 0.05);
                if(withdrawalwithTax >= 1050) {
                    $$('.block-moneyTransfer').removeClass('hidden');
                    $$('.withdrawMoney').removeClass('disabled');
                    var withdrwalAmount = withdrawalwithTax - (withdrawalwithTax * 0.05);
                    withdrwalAmount = parseFloat(withdrwalAmount).toFixed(2);
                    $$('.wd-balST').removeClass('text-color-red-deep');
                    $$('.wd-balST').addClass('text-color-blue');
                    $$('.wd-balST').html('You can withdraw up to '+INR2.format(item.maxWithdrawal)+' from your investment.');
                  } else {
                    $$('.withdrawMoney').addClass('disabled');
                  }
              }
              $('#investmentSelect').on('change', function() {
                var investID = $$('#investmentSelect').val();
                //match investment id with selected investment
                if(item.investID == investID) {
                  $$('.wallet--amount').html(INR2.format(item.withdrawalLimit));
                  $$('input[name="amount"]').attr('max', item.maxWithdrawal);
                  $$('input[name="wallet"]').val(item.withdrawalLimit);
                  if(item.withdrawn == 0) {
                    $$('.card__warning').removeClass('hidden');
                    $$('.holding-date').html(item.halfwayDate);
                    $$('.gold-amount').html(INR2.format(item.wallet));
                  } else {
                    $$('.card__warning').removeClass('hidden');
                    $$('.card__warning-txt').html('As you have already withdrawn your investment, you can not get gold benefits from this investment anymore.');
                  }
                  //calculate item.withdrawalLimit + 5%, if it's 1000 then it should be 1050
                  var withdrawalwithTax = +item.withdrawalLimit + +(item.withdrawalLimit * 0.05);
                  if(withdrawalwithTax >= 1050) {
                    $$('.block-moneyTransfer').removeClass('hidden');
                    $$('.withdrawMoney').removeClass('disabled');
                    var withdrwalAmount = withdrawalwithTax - (withdrawalwithTax * 0.05);
                    withdrwalAmount = parseFloat(withdrwalAmount).toFixed(2);
                    $$('.wd-balST').removeClass('text-color-red-deep');
                    $$('.wd-balST').addClass('text-color-blue');
                    $$('.wd-balST').html('You can withdraw up to '+INR2.format(item.maxWithdrawal)+' from your investment.');
                  } else {
                    $$('.withdrawMoney').addClass('disabled');
                  }
                }
              });
              if(item.isWeekend == true) {
                $$('.w-timetxt').html('Withdrawals are not allowed on weekends, you can withdraw on next business day.');
                $$('.withdrawMoney').addClass('disabled');
              } else {
                $$('.w-timetxt').html('');
              }
            });
          } else {
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            //check if bankAccounts is array or not
            if(Array.isArray(data.bankAccounts) && data.bankAccounts.length > 0) {
              $$('#investWithFrm').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').removeClass('hidden');
              var allBankAccounts = data.bankAccounts;
              //create bank account select list in selectBeneficiary
              $$('.selectBeneficiary').empty();
              allBankAccounts.forEach(function(account, idx) {
                $$('#selectBeneficiary').append(
                  '<option value="'+account.bankAC+'"'
                  + ' data-beneficiary="'+account.beneficiaryName+'"'
                  + ' data-bankname="'+account.bankName+'"'
                  + ' data-ifsc="'+account.bankIFSC+'"'
                  + ' data-receiverphone="'+account.receiverPhone+'"'
                  + ' data-receiveremail="'+account.receiverMail+'"'
                  + (idx === 0 ? ' selected' : '')
                  + '>'
                  + account.beneficiaryName+' - '+account.bankAC+' ('+account.bankName+')'
                  + '</option>'
                );
              });
              //init select2
              $('#selectBeneficiary').select2();
              $$('.block-beneficiaryDetails').removeClass('hidden');
              //first show selected beneficiary details
              var selectedBeneficiary = $('#selectBeneficiary option:selected');
              $$('.block-beneficiaryDetails').empty();
              $$('.block-beneficiaryDetails').append('<div class="card card-main">\
                <div class="card-content">\
                  <p class="text-color-blue f-14"><b>Beneficiary Name:</b> '+selectedBeneficiary.data('beneficiary')+'</p>\
                  <p class="text-color-blue f-14"><b>Bank Name:</b> '+selectedBeneficiary.data('bankname')+'</p>\
                  <p class="text-color-blue f-14"><b>Account Number:</b> '+selectedBeneficiary.val()+'</p>\
                  <p class="text-color-blue f-14"><b>IFSC Code:</b> '+selectedBeneficiary.data('ifsc')+'</p>\
                  <p class="text-color-blue f-14"><b>Beneficiary Phone:</b> '+selectedBeneficiary.data('receiverphone')+'</p>\
                  <p class="text-color-blue f-14"><b>Beneficiary Email:</b> '+selectedBeneficiary.data('receiveremail')+'</p>\
                </div>\
              </div>');
              //beneficiary content add value to each field
              $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
              $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
              $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
              $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
              $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              //on change of select box of beneficiary
              $('#selectBeneficiary').on('change', function() {
                var selectedBeneficiary = $('#selectBeneficiary option:selected');
                $$('.block-beneficiaryDetails').empty();
                $$('.block-beneficiaryDetails').append('<div class="card card-main">\
                  <div class="card-content">\
                    <p class="text-color-blue f-14"><b>Beneficiary Name:</b> '+selectedBeneficiary.data('beneficiary')+'</p>\
                    <p class="text-color-blue f-14"><b>Bank Name:</b> '+selectedBeneficiary.data('bankname')+'</p>\
                    <p class="text-color-blue f-14"><b>Account Number:</b> '+selectedBeneficiary.val()+'</p>\
                    <p class="text-color-blue f-14"><b>IFSC Code:</b> '+selectedBeneficiary.data('ifsc')+'</p>\
                    <p class="text-color-blue f-14"><b>Beneficiary Phone:</b> '+selectedBeneficiary.data('receiverphone')+'</p>\
                    <p class="text-color-blue f-14"><b>Beneficiary Email:</b> '+selectedBeneficiary.data('receiveremail')+'</p>\
                  </div>\
                </div>');
                //beneficiary content add value to each field
                $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
                $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
                $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
                $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
                $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              });
            } else {
              $$('#investWithFrm').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').addClass('hidden');
            }
            //create the add-beneficiary popup
            // Create Add Beneficiary Sheet
            var addBeneficiaryPopup = app.popup.create({
              content: `
              <div class="popup ypw-addpayee-popup add-beneficiary-popup">
                <div class="view">
                  <div class="page">
                    <div class="navbar ypw-appbar no-shadow">
                      <div class="navbar-bg"></div>
                      <div class="navbar-inner ypw-appbar__inner">
                        <div class="left">
                          <a href="#" class="link icon-only popup-close no-ripple ypw-appbar__btn" aria-label="Close">
                            <svg class="ypw-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14.5 5.5-6.5 6.5 6.5 6.5"/></svg>
                          </a>
                        </div>
                        <div class="title">Add bank account</div>
                      </div>
                    </div>
                    <div class="page-content ypw-addpayee-popup__content">
                      <form id="addBeneficiaryForm" class="ypw-form">
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnbeneficiary">Beneficiary name</label>
                          <div class="ypw-control">
                            <input type="text" name="bnbeneficiary" id="bnbeneficiary" required validate placeholder="Name as per bank records">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnaccount">Account number</label>
                          <div class="ypw-control">
                            <input type="password" name="bnaccount" id="bnaccount" inputmode="numeric" required validate placeholder="Enter account number">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bncaccount">Confirm account number</label>
                          <div class="ypw-control">
                            <input type="tel" name="bncaccount" id="bncaccount" inputmode="numeric" required validate placeholder="Re-enter account number">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnifsc">IFSC Code</label>
                          <div class="ypw-control">
                            <input type="text" name="bnifsc" id="bnifsc" minlength="11" maxlength="11" required validate placeholder="e.g. HDFC0001234">
                          </div>
                          <p class="ypw-error"></p>
                          <p class="ypw-hint">We'll look up the bank name for you.</p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnbankname">Bank name</label>
                          <div class="ypw-control">
                            <input type="text" name="bnbankname" id="bnbankname" required validate placeholder="Bank name">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnreceiverPhone">Phone <span class="ypw-label__opt">optional</span></label>
                          <div class="ypw-control">
                            <input type="tel" maxlength="10" minlength="10" name="bnreceiverPhone" id="bnreceiverPhone" inputmode="numeric" placeholder="10-digit number">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-field">
                          <label class="ypw-label" for="bnreceiverEmail">Email <span class="ypw-label__opt">optional</span></label>
                          <div class="ypw-control">
                            <input type="email" name="bnreceiverEmail" id="bnreceiverEmail" validate placeholder="name@example.com">
                          </div>
                          <p class="ypw-error"></p>
                        </div>
                        <div class="ypw-actions">
                          <button type="submit" class="button button-large button-fill bg-color-red addBeneficiaryBtn">Add beneficiary</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              `,
              // Events
              on: {
                open: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                },
                opened: function() {
                  //get ifsc
                  $(document).on('keyup', '#bnifsc', function() {
                    if($$('#bnifsc').val().length == 11) {
                      app.preloader.show();
                      $.getJSON('https://ifsc.razorpay.com/'+$$('#bnifsc').val(), function(data) {app.preloader.hide();})
                      .done(function(data) {
                        app.preloader.hide();
                        $$('#bnbankname').val(data.BANK);
                        $$('.item-input-bank').addClass('item-input-focused');
                        $$('.item-input-bank').addClass('item-input-with-value');
                      })
                      .fail(function() {
                        app.preloader.hide();
                        app.toast.show({
                          text: 'Invalid IFSC code!',
                          closeTimeout: 3000,
                        });
                      })
                    }
                  });
                  // Handle Add Beneficiary Form Submission
                  /* Bound once, on the form itself. `opened` fires on every
                     open, and the delegated $(document).on('submit', ...) this
                     replaces stacked another handler each time -- after three
                     opens one tap sent three requests. */
                  /* `this` is the popup instance whose event fired (F7 emits
                     with context = the instance). The outer addBeneficiaryPopup
                     variable is not safe here: if the route initialises twice it
                     points at the newer popup, and the older popup's opened would
                     bind the listener to a detached form -- submitting then did
                     nothing at all. */
                  var thisPopup = this;
                  var beneficiaryFormEl = thisPopup.el.querySelector('#addBeneficiaryForm');
                  if (!beneficiaryFormEl.dataset.submitBound) {
                  beneficiaryFormEl.dataset.submitBound = '1';

                  /* A custom error must not outlive the edit that fixes it. */
                  beneficiaryFormEl.addEventListener('input', function(e) {
                    if (e.target.setCustomValidity) e.target.setCustomValidity('');
                  });

                  beneficiaryFormEl.addEventListener('submit', function(e) {
                    e.preventDefault();

                    /* The cross-field rule and the server's own limits cannot be
                       expressed as HTML constraints, so they are pushed into the
                       same constraint API the validator reads. Everything wrong
                       is then reported together, inline on the field it belongs
                       to, rather than one toast per round of guessing. */
                    var accountEl = beneficiaryFormEl.querySelector('#bnaccount');
                    var confirmEl = beneficiaryFormEl.querySelector('#bncaccount');
                    var ifscEl = beneficiaryFormEl.querySelector('#bnifsc');

                    accountEl.setCustomValidity(accountNumberError(accountEl.value) || '');
                    ifscEl.setCustomValidity(ifscError(ifscEl.value) || '');
                    confirmEl.setCustomValidity(
                      accountEl.value !== confirmEl.value ? 'Account numbers do not match' : ''
                    );

                    /* Marks every bad field, focuses the first, returns false. */
                    if (!validateScope(beneficiaryFormEl)) return;

                    var formData = app.form.convertToData('#addBeneficiaryForm');
                    formData.addBeneficiary = true;
                    formData.token = localStorage.getItem('authToken');
                    app.dialog.progress('Adding...');
                    /* app.methods.request, not app.request.post: it goes through
                       the wrapped $.ajax, so a 400 still carries the server's
                       `msg` instead of looking like a dropped connection. */
                    app.methods.request(
                    baseURL + '/app/php/lockers.php',
                    formData,
                    'json',
                    function() {},
                    function(data) {
                      app.dialog.close();
                      if (data && data.status === 'success') {
                      app.toast.show({ text: 'Beneficiary added successfully!', closeTimeout: 2000 });
                      thisPopup.close();
                      // Optionally, reload the page or update the beneficiary list here
                      //RELOAD CURRENT PAGE
                      var view = app.views.current;
                      view.router.navigate('/invest-withdraw/', {
                        reloadCurrent: true,
                        ignoreCache: true,
                      })
                      } else {
                      app.toast.show({ text: (data && data.msg) || 'Failed to add beneficiary.', closeTimeout: 4000 });
                      }
                    },
                    function() {
                      app.dialog.close();
                      app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 });
                    }
                    );
                  });
                  }
                },
                close: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                }
              }
            });
            // Open Add Beneficiary Sheet on button click
            $$('.add-beneficiary-btn').on('click', function() {
              addBeneficiaryPopup.open();
            });
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        //get ifsc
        $$('#ifsc').on('keyup', function() {
          if($$('#ifsc').val().length == 11) {
            app.preloader.show();
            $.getJSON('https://ifsc.razorpay.com/'+$$('#ifsc').val(), function(data) {app.preloader.hide();})
            .done(function(data) {
              app.preloader.hide();
              $$('#bankname').val(data.BANK);
              $$('.item-input-bank').addClass('item-input-focused');
              $$('.item-input-bank').addClass('item-input-with-value');
            })
            .fail(function() {
              app.preloader.hide();
              app.toast.show({
                text: 'Invalid IFSC code!',
                closeTimeout: 3000,
              });
            })
          }
        });
        //submit withdrawal request
        $$('.withdrawMoney').on('click', function() {
          if (!$$('#investWithFrm')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            withdrawMoney();
          }
        });
        function withdrawMoney() {
          var beneficiaryProblem =
            accountNumberError($$('#investWithFrm #account').val()) ||
            ifscError($$('#investWithFrm #ifsc').val());
          if(beneficiaryProblem) {
            app.toast.show({ text: beneficiaryProblem, closeTimeout: 4000 });
            return;
          }
          /* withdrawRequest now requires `wallet >= amount + 5% fee`; the fee
             used to be left out, which could push a wallet negative. Same
             arithmetic here so the user sees it before submitting. */
          var amount = parseFloat($$('#investWithFrm input[name="amount"]').val()) || 0;
          var investWallet = parseFloat($('#investmentSelect option:selected').data('wallet'));
          var fee = amount * 0.05;
          if(!isNaN(investWallet) && (amount + fee) > investWallet) {
            app.toast.show({
              text: 'Insufficient wallet balance! ' + INR2.format(amount) + ' plus the '
                + INR2.format(fee) + ' withdrawal fee comes to ' + INR2.format(amount + fee)
                + ', more than the ' + INR2.format(investWallet) + ' in this investment.',
              closeTimeout: 5000,
            });
            return;
          }
          var formdata = $('#investWithFrm').serialize();
          var data = formdata+'&withdrawRequest=true&token='+localStorage.getItem('authToken');
          app.methods.request(
            baseURL+'/app/php/invest.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet-loan--applied');
                $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Withdrawal Requested!');
                $$('.sheet-loan--applied__text').html('Money will be transferred to your bank account once we verify your withdrawal, please wait while we\'re verifying your withdrawal.');
                var view = app.views.current;
                view.router.back('/invest-dashboard/',{force:true});
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    /* In-app KYC (API-KYC.md). The page is static markup; kyc.js shows the
       parts for the customer's state from kycStatus, which is asked afresh
       every time the screen opens -- there is no push when a review ends. */
    path: '/kyc/',
    beforeEnter: requireSignIn,
    component: KycPage,
    name: 'kyc',
    on: {
      pageInit: function(e, page) {
        initKycPage(this.app, page, baseURL);
      },
      //drops the resized photos and the typed PAN / Aadhaar with the page
      pageBeforeRemove: function(e, page) {
        destroyKycPage(page);
      },
    }
  },
  {
    /* Wallet limits for the customer's KYC level, used-of-limit, from the
       same kycStatus call */
    path: '/wallet-limits/',
    beforeEnter: requireSignIn,
    component: WalletLimitsPage,
    name: 'wallet-limits',
    on: {
      pageInit: function(e, page) {
        initLimitsPage(this.app, page, baseURL);
      },
      pageBeforeRemove: function(e, page) {
        destroyKycPage(page);
      },
    }
  },
  {
    path: '(.*)',
    component: NotFoundPage,
    on: {
      pageInit: function() {
        $$('.url').html(window.location);
      }
    }
  },
];

export default routes;